(() => {

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Panel-App
// Libs
'use strict';
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const { iterator: $aace3e920a0f1e4d$var$iterator, toStringTag: $aace3e920a0f1e4d$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $aace3e920a0f1e4d$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $aace3e920a0f1e4d$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $aace3e920a0f1e4d$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($aace3e920a0f1e4d$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $aace3e920a0f1e4d$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(obj);
        if ($aace3e920a0f1e4d$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($aace3e920a0f1e4d$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $aace3e920a0f1e4d$var$getSafeProp = (obj, prop)=>obj != null && $aace3e920a0f1e4d$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $aace3e920a0f1e4d$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $aace3e920a0f1e4d$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $aace3e920a0f1e4d$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $aace3e920a0f1e4d$var$getPrototypeOf(current);
        if ($aace3e920a0f1e4d$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($aace3e920a0f1e4d$var$isUnsafeObjectKey(prop)) continue;
            if (!$aace3e920a0f1e4d$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if (!$aace3e920a0f1e4d$var$isObject(val)) return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $aace3e920a0f1e4d$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$aace3e920a0f1e4d$var$hasOwnInPrototypeChain(val, $aace3e920a0f1e4d$var$toStringTag) && !$aace3e920a0f1e4d$var$hasOwnInPrototypeChain(val, $aace3e920a0f1e4d$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $aace3e920a0f1e4d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$aace3e920a0f1e4d$var$isObject(val) || $aace3e920a0f1e4d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $aace3e920a0f1e4d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest('FileList');
const $aace3e920a0f1e4d$var$isSet = $aace3e920a0f1e4d$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $aace3e920a0f1e4d$var$G = $aace3e920a0f1e4d$var$getGlobal();
const $aace3e920a0f1e4d$var$FormDataCtor = typeof $aace3e920a0f1e4d$var$G.FormData !== 'undefined' ? $aace3e920a0f1e4d$var$G.FormData : undefined;
const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($aace3e920a0f1e4d$var$FormDataCtor && thing instanceof $aace3e920a0f1e4d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $aace3e920a0f1e4d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$aace3e920a0f1e4d$var$isFunction(thing.append)) return false;
    const kind = $aace3e920a0f1e4d$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest('URLSearchParams');
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($aace3e920a0f1e4d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $aace3e920a0f1e4d$var$findKey(obj, key) {
    if ($aace3e920a0f1e4d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $aace3e920a0f1e4d$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($aace3e920a0f1e4d$var$isPlainObject(existing) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(existing, val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$aace3e920a0f1e4d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $aace3e920a0f1e4d$var$isBuffer(source)) continue;
        $aace3e920a0f1e4d$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $aace3e920a0f1e4d$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($aace3e920a0f1e4d$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$aace3e920a0f1e4d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest('HTMLFormElement');
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $aace3e920a0f1e4d$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest('RegExp');
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[$aace3e920a0f1e4d$var$toStringTag] === 'FormData' && thing[$aace3e920a0f1e4d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($aace3e920a0f1e4d$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($aace3e920a0f1e4d$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                    $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $aace3e920a0f1e4d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $aace3e920a0f1e4d$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $aace3e920a0f1e4d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $aace3e920a0f1e4d$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $aace3e920a0f1e4d$var$isFunction($aace3e920a0f1e4d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $aace3e920a0f1e4d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($aace3e920a0f1e4d$var$_global) : $aace3e920a0f1e4d$var$_setImmediate;
// *********************
const $aace3e920a0f1e4d$var$isIterable = (thing)=>thing != null && $aace3e920a0f1e4d$var$isFunction(thing[$aace3e920a0f1e4d$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $aace3e920a0f1e4d$var$isSafeIterable = (thing)=>thing != null && $aace3e920a0f1e4d$var$hasOwnInPrototypeChain(thing, $aace3e920a0f1e4d$var$iterator) && $aace3e920a0f1e4d$var$isIterable(thing);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isEmptyObject: $aace3e920a0f1e4d$var$isEmptyObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isReactNativeBlob: $aace3e920a0f1e4d$var$isReactNativeBlob,
    isReactNative: $aace3e920a0f1e4d$var$isReactNative,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnInPrototypeChain: $aace3e920a0f1e4d$var$hasOwnInPrototypeChain,
    getSafeProp: $aace3e920a0f1e4d$var$getSafeProp,
    toSafeFlatObject: $aace3e920a0f1e4d$var$toSafeFlatObject,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable,
    setImmediate: $aace3e920a0f1e4d$var$_setImmediate,
    asap: $aace3e920a0f1e4d$var$asap,
    isIterable: $aace3e920a0f1e4d$var$isIterable,
    isSafeIterable: $aace3e920a0f1e4d$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp($36eacf0f5ae88424$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $0e9de7e2c09a763b$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $0e9de7e2c09a763b$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $0e9de7e2c09a763b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $0e9de7e2c09a763b$var$sanitizeValue(value, invalidChars) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$0e9de7e2c09a763b$var$sanitizeValue(item, invalidChars));
    return $0e9de7e2c09a763b$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $0e9de7e2c09a763b$export$9e344cffce061a22 = (value)=>$0e9de7e2c09a763b$var$sanitizeValue(value, $0e9de7e2c09a763b$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $0e9de7e2c09a763b$export$59dd66c2a12d8f62 = (value)=>$0e9de7e2c09a763b$var$sanitizeValue(value, $0e9de7e2c09a763b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $0e9de7e2c09a763b$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $0e9de7e2c09a763b$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $54e5234108b8e954$var$$internals = Symbol('internals');
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : (0, $0e9de7e2c09a763b$export$9e344cffce061a22)(String(value));
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $54e5234108b8e954$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $54e5234108b8e954$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $54e5234108b8e954$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $54e5234108b8e954$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $54e5234108b8e954$var$trimOWS(part.slice(0, equals));
        if (!$54e5234108b8e954$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $54e5234108b8e954$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $54e5234108b8e954$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(header) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $54e5234108b8e954$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


'use strict';
const $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $0139f1d30f4d6bd5$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $0139f1d30f4d6bd5$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source) && $0139f1d30f4d6bd5$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $0139f1d30f4d6bd5$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $0139f1d30f4d6bd5$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $0139f1d30f4d6bd5$var$stringifySafely(entry.message) : $0139f1d30f4d6bd5$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $0139f1d30f4d6bd5$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $0139f1d30f4d6bd5$var$aggregateErrorMessage(error);
        const axiosError = new $0139f1d30f4d6bd5$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $0139f1d30f4d6bd5$var$redactConfig(config, redactKeys) : (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$0139f1d30f4d6bd5$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$0139f1d30f4d6bd5$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$0139f1d30f4d6bd5$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$0139f1d30f4d6bd5$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$0139f1d30f4d6bd5$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$0139f1d30f4d6bd5$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$0139f1d30f4d6bd5$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$0139f1d30f4d6bd5$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;



'use strict';
const $fd07b9cb0132c1f6$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $fd07b9cb0132c1f6$export$659081b45d03227d);
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) && (0, $86ebf0c810395e29$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $86ebf0c810395e29$export$2e2bcd8739ae039).from(value);
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNative(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $344cf8e4292137b6$var$encode) : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


'use strict';
function $db2f05ec923f2ee7$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $db2f05ec923f2ee7$export$c564cdbbe6da493;
    const serializeFn = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
const $01c17f80085c95b1$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $01c17f80085c95b1$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $01c17f80085c95b1$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $01c17f80085c95b1$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $01c17f80085c95b1$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$01c17f80085c95b1$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$01c17f80085c95b1$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$01c17f80085c95b1$var$$internals];
        $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $01c17f80085c95b1$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $01c17f80085c95b1$var$syncHandlerEntries(this, this[$01c17f80085c95b1$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$01c17f80085c95b1$var$$internals];
        $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $01c17f80085c95b1$var$syncHandlerEntries(this, internals);
                $01c17f80085c95b1$var$trimHandlers(this.handlers);
                internals.handlersLength = $01c17f80085c95b1$var$countHandlers(this.handlers);
            }
        }
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





'use strict';
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


'use strict';
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $232de52881daaba8$exports = {};

$parcel$export($232de52881daaba8$exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export($232de52881daaba8$exports, "navigator", () => $232de52881daaba8$export$ec7c8efa7f5790ae);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export($232de52881daaba8$exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $232de52881daaba8$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = $232de52881daaba8$export$c4996c4b7b93b0bf && (!$232de52881daaba8$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($232de52881daaba8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$232de52881daaba8$exports,
    ...(0, $fb24c6d0b2a74508$export$2e2bcd8739ae039)
};


'use strict';
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $cb8fe7f388dc4432$var$MAX_DEPTH = (0, $fd07b9cb0132c1f6$export$659081b45d03227d);
function $cb8fe7f388dc4432$var$throwIfDepthExceeded(index) {
    if (index > $cb8fe7f388dc4432$var$MAX_DEPTH) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $cb8fe7f388dc4432$var$MAX_DEPTH, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $cb8fe7f388dc4432$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $cb8fe7f388dc4432$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


'use strict';
const $646cd75d44c49c4c$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $646cd75d44c49c4c$export$2e2bcd8739ae039 = $646cd75d44c49c4c$var$methodList;


'use strict';
const $e30871f78dcd7f19$var$own = (obj, key)=>obj != null && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $e30871f78dcd7f19$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $e30871f78dcd7f19$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $e30871f78dcd7f19$var$own(this, 'transitional') || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $e30871f78dcd7f19$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isResponse(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $e30871f78dcd7f19$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $e30871f78dcd7f19$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach((0, $646cd75d44c49c4c$export$2e2bcd8739ae039), (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;



'use strict';
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $63b8b72909769bf2$var$CanceledError extends (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







'use strict';
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
const $833fb3017515f4b1$var$urlParserControlCharacters = /[\t\n\r]/g;
function $833fb3017515f4b1$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($833fb3017515f4b1$var$urlParserControlCharacters, '');
}


'use strict';
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;



const $a01f222f203440ec$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (0, $bab2be24834f7155$export$2e2bcd8739ae039)((e)=>{
        if (!e || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a01f222f203440ec$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a01f222f203440ec$export$5d35863c355a22a9 = (fn, scheduler = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin), (0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
const $8ed3292b1f9dccb5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $8ed3292b1f9dccb5$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b}`;
    });
}
function $8ed3292b1f9dccb5$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $0139f1d30f4d6bd5$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$8ed3292b1f9dccb5$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $8ed3292b1f9dccb5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $833fb3017515f4b1$export$2e2bcd8739ae039)(url);
        if ($8ed3292b1f9dccb5$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($8ed3292b1f9dccb5$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $8ed3292b1f9dccb5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $8ed3292b1f9dccb5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $20ede3a7e8b675d4$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), prop, true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($20ede3a7e8b675d4$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $33eeece7a5eadfb1$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $33eeece7a5eadfb1$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($33eeece7a5eadfb1$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $f612969e780f42a0$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $f612969e780f42a0$var$resolveConfig(config) {
    const newConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)((0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $f612969e780f42a0$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
        const getHeaders = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $33eeece7a5eadfb1$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $f612969e780f42a0$export$2e2bcd8739ae039 = $f612969e780f42a0$var$resolveConfig;



const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)((0, $833fb3017515f4b1$export$2e2bcd8739ae039)(_config.url)) || (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request aborted', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request aborted', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(msg, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach((0, $0e9de7e2c09a763b$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $852831b4a152a7ad$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) ? err : new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;


const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ac31e9e363273572$var$readStream(iterable))yield* $ac31e9e363273572$export$71b051935044bd5d(chunk, chunkSize);
};
const $ac31e9e363273572$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $9da0c0d713764234$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $9da0c0d713764234$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $9da0c0d713764234$var$isHexDigit(str.charCodeAt(i + 1)) && $9da0c0d713764234$var$isHexDigit(str.charCodeAt(i + 2));
const $9da0c0d713764234$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $9da0c0d713764234$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $9da0c0d713764234$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $9da0c0d713764234$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $9da0c0d713764234$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $9da0c0d713764234$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $9da0c0d713764234$var$isPercentEncodedByte(body, i, len)) {
            code = $9da0c0d713764234$var$hexValue(body.charCodeAt(i + 1)) * 16 + $9da0c0d713764234$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($9da0c0d713764234$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$9da0c0d713764234$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $9da0c0d713764234$var$estimateBase64BufferAllocation(body);
    return $9da0c0d713764234$var$base64Bytes(significant);
};
const $9da0c0d713764234$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $9da0c0d713764234$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $9da0c0d713764234$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $9da0c0d713764234$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $9da0c0d713764234$var$estimatePercentDecodedBase64Bytes);
}
function $9da0c0d713764234$export$1f39e64b554a246f(url) {
    return $9da0c0d713764234$var$estimateDataURLBytes(url, $9da0c0d713764234$var$estimateBase64BufferAllocation);
}


const $4c74d331112ba968$export$a4ad2735b021c132 = "1.20.0";



const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const $4b9898a31eea6843$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $4b9898a31eea6843$var$isFunction } = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $4b9898a31eea6843$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $4b9898a31eea6843$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $4b9898a31eea6843$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4b9898a31eea6843$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $4b9898a31eea6843$var$factory = (env)=>{
    const globalObject = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global !== undefined && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global !== null ? (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $4b9898a31eea6843$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $4b9898a31eea6843$var$isFunction(Request);
    const isResponseSupported = $4b9898a31eea6843$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $4b9898a31eea6843$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $8bc8ab02f7e95517$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($4b9898a31eea6843$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $4b9898a31eea6843$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $4b9898a31eea6843$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($4b9898a31eea6843$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $9da0c0d713764234$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $ac31e9e363273572$export$b0119225647bd83)(stream, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $a01f222f203440ec$export$d9fadd12586c18d6)(requestContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $4c74d331112ba968$export$a4ad2735b021c132), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $0e9de7e2c09a763b$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($4b9898a31eea6843$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $a01f222f203440ec$export$d9fadd12586c18d6)(responseContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $ac31e9e363273572$export$b0119225647bd83)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Network Error', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $4b9898a31eea6843$var$seedCache = new Map();
const $4b9898a31eea6843$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $4b9898a31eea6843$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $4b9898a31eea6843$var$factory(env));
        map = target;
    }
    return target;
};
const $4b9898a31eea6843$var$adapter = $4b9898a31eea6843$export$3105c6651375d4fa();
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039),
    fetch: {
        get: $4b9898a31eea6843$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $d570c100e0cb7a05$var$getAdapter(adapters, config) {
    adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d570c100e0cb7a05$var$renderReason).join('\n') : ' ' + $d570c100e0cb7a05$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $d570c100e0cb7a05$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $d570c100e0cb7a05$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $4c74d331112ba968$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$63efb8494987aa98$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('options must be an object', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};




'use strict';
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            legacyInterceptorReqResOrdering: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            advertiseZstdAcceptEncoding: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            validateStatusUndefinedResolves: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $cd0b8e3cbef64068$var$validators.spelling('baseURL'),
            withXsrfToken: $cd0b8e3cbef64068$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach((0, $646cd75d44c49c4c$export$2e2bcd8739ae039).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $cd0b8e3cbef64068$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






'use strict';
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    if ($edd7ef3f6e3b67e5$var$HttpStatusCode[value] === undefined) $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a, create: $125d1ceb57662f9a$export$185802fd694ee1f5 } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);


var $dbe7c8f2fb929f48$require$axios = $5d7526a7a1e5b3fb$export$2e2bcd8739ae039;
class $dbe7c8f2fb929f48$export$1e7deca84b429035 {
    #config = {
        headers: {
            'Accept': 'application/json',
            'x-requested-with': 'xmlhttprequest'
        }
    };
    constructor(config){
        // Konfiguration zusammenstellen
        if (config && typeof config === "object") this.#config = {
            ...this.#config,
            ...config
        };
        return this;
    }
    async get(endpoint) {
        return this.#send("get", endpoint, null);
    }
    async put(endpoint, body) {
        return this.#send("put", endpoint, body);
    }
    async post(endpoint, body) {
        return this.#send("post", endpoint, body);
    }
    async delete(endpoint, body) {
        return this.#send("delete", endpoint, body);
    }
    async #send(method, endpoint, body) {
        let options = {
            method: method,
            url: endpoint
        };
        if (body) options.data = body;
        options = {
            ...this.#config,
            ...options
        };
        return new Promise((resolve, reject)=>{
            $dbe7c8f2fb929f48$require$axios.request(options).then((response)=>{
                // No Success
                if (response.data?.success !== true) {
                    let msg = response.data.error_msg ?? "Unknown error";
                    reject({
                        "message": msg,
                        "response": response
                    });
                } else resolve(response.data);
            }).catch((error)=>{
                if (typeof error !== "object") error = {
                    message: error
                };
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    error.message = error.message ?? "Server error";
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                    error.message = error.message ?? "No response";
                }
                reject(error);
            });
        });
    }
}


class $bd2663108f285dbc$export$86fbec116b87613f {
    //static #app_was_loggedin = false;
    static #app_timeout_ping = setTimeout(()=>{
        $bd2663108f285dbc$export$86fbec116b87613f.ping();
    }, 600000);
    // Prüft ob DOM geladen und führt Callback aus
    static domready(fn) {
        if (document.readyState != 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }
    // Liefert Panel-URL
    static getUrl(controller = '', action = '', parameter = '', get_parameter = []) {
        // Parameter initialisieren
        if (typeof controller === "undefined") controller = "";
        if (typeof action === "undefined") action = "";
        if (typeof parameter === "undefined") parameter = "";
        if (typeof parameter === "number") parameter = parameter.toString();
        if (typeof get_parameter === "undefined") get_parameter = [];
        // Parameter prüfen
        if (typeof controller !== "string") return false;
        if (typeof action !== "string") return false;
        if (typeof parameter !== "string") return false;
        if (typeof get_parameter !== "object") return false;
        // Parameter bereinigen
        controller = controller.trim();
        action = action.trim();
        if (typeof parameter === "string") parameter = parameter.trim();
        // URL zusammenstellen
        let url = window.location.protocol + "//" + window.location.hostname + '/panel/';
        if (controller.length > 0) {
            url += controller + '/';
            if (action.length > 0) url += action + '/';
            if (parameter.length > 0) {
                if (action.length === 0) url += 'index/';
                url += parameter + '/';
            }
        }
        url = url.substring(0, url.length - 1);
        if (typeof get_parameter === "object") {
            url += '?';
            Object.entries(get_parameter).forEach(([key, value])=>{
                value = value.toString();
                if (key.length > 0 && value.length > 0) url += key.trim() + '=' + value.trim() + '&';
            });
            url = url.substring(0, url.length - 1);
        }
        // liefern
        return url;
    }
    // Weiterleitung zu Panel-Seite
    static goto(controller, action = '', parameter = '', get_parameter = []) {
        let url = $bd2663108f285dbc$export$86fbec116b87613f.getUrl(controller, action, parameter, get_parameter);
        if (url === false) {
            console.log("Konnte URL f\xfcr Seitenweiterleitung nicht erstellen!");
            return;
        }
        $bd2663108f285dbc$export$86fbec116b87613f.gotoUrl(url);
    }
    // Weiterleitung zu URL
    static gotoUrl(url) {
        window.location = url;
    }
    // Liefert Code der aktuellen Sprache
    static getLang() {
        const $html = document.querySelector('html');
        const lang = $html.getAttribute('lang');
        return lang;
    }
    // Ping zur Prüfung des Login-Status ausführen
    static ping() {
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get($bd2663108f285dbc$export$86fbec116b87613f.getUrl('ping'), null).then((data)=>{
        // Übrprüfung des Login-Status auskommentiert, da es häufig zu fehlerhaften Weiterleitungen gekommen ist
        // if(data.loggedin == true) {
        //     this.#app_was_loggedin = true;
        // }
        // else if(data.loggedin == false) {
        //     // war bereits eingeloggt
        //     // ... Weiterleitung zu Login
        //     if(this.#app_was_loggedin) {
        //         App.goto('login', '', '', { 'session': 'expired' });
        //         return;
        //     }
        //     this.#app_was_loggedin = false;
        //     return;
        // }
        }).finally(()=>{
            // wieder in 10 Min. ausführen
            this.#app_timeout_ping = setTimeout(()=>{
                $bd2663108f285dbc$export$86fbec116b87613f.ping();
            }, 600000);
        });
    }
    // Sendebuttons eines Formulars auf Ladestatus setzen
    static setSubmitBtnLoading($form) {
        let $btns = $form.querySelectorAll('button[type=submit]');
        $btns.forEach((el)=>{
            el.classList.add('loading');
            el.setAttribute('disabled', true);
        });
    }
    // Sendebuttons eines Formulars auf Aktiv setzen
    static setSubmitBtnActive($form) {
        let $btns = $form.querySelectorAll('button[type=submit]');
        $btns.forEach((el)=>{
            el.classList.remove('loading');
            el.removeAttribute('disabled');
        });
    }
    // Spinner-Area einblenden
    static showSpinnerArea(selector) {
        let ele = document.querySelector(selector);
        if (ele) {
            ele.style.visibility = 'visible';
            ele.classList.add('show');
        }
    }
    // Spinner-Area ausblenden
    static hideSpinnerArea(selector) {
        let ele = document.querySelector(selector);
        if (ele) {
            ele.classList.remove('show');
            ele.style.visibility = 'hidden';
        }
    }
    // kleine CSS Animation
    static animateCSS(node, animation) {
        new Promise((resolve, reject)=>{
            node.classList.add('vivify', animation);
            function handleAnimationEnd() {
                node.classList.remove('vivify', animation);
                node.removeEventListener('animationend', handleAnimationEnd);
                resolve('Animation ended');
            }
            node.addEventListener('animationend', handleAnimationEnd);
        });
    }
}


// Klasse Popup
class $d19f7743c2a8a520$export$129a32eedafa97c5 {
    constructor($ele, callbackOpen = null){
        this.$container = $ele;
        this.callbackOpen = callbackOpen;
        // Button
        this.$btn = this.$container.querySelector(".popup-btn");
        if (!this.$btn) {
            console.error("Popup-Button nicht gefunden!");
            return;
        }
        // Popup Display
        if ($ele.hasAttribute("data-popup-display-selector")) this.$popupDisplay = document.querySelector($ele.getAttribute("data-popup-display-selector"));
        else this.$popupDisplay = this.$container.querySelector(".popup-display");
        if (!this.$popupDisplay) {
            console.error("Popup-Element nicht gefunden!");
            return;
        }
        // Klick auf Button
        this.$btn.addEventListener("click", (event)=>{
            event.stopPropagation();
            this.toggle();
        });
        // Close-Buttons im Popup
        const $closeBtns = this.$popupDisplay.querySelectorAll(".popup-close-btn");
        $closeBtns.forEach(($btn)=>{
            $btn.addEventListener("click", (event)=>{
                this.close();
            });
        });
    }
    // Popup einblenden
    open() {
        if (!this.$container.classList.contains("open")) {
            this.close = this.close.bind(this);
            document.addEventListener("click", this.close);
            document.addEventListener("keyup", this.close);
            this.$popupDisplay.removeAttribute("hidden");
            this.$btn.setAttribute("aria-expanded", "true");
            const reflow = this.$popupDisplay.offsetHeight;
            this.$container.classList.add("open");
            if (this.callbackOpen) this.callbackOpen(this);
        }
    }
    // Popup schliessen
    close(event = null) {
        if (this.$container.classList.contains("open")) {
            if (event) {
                if (event.type === "click") {
                    let targetElement = event.target;
                    do {
                        if (targetElement == this.$popupDisplay) return;
                        targetElement = targetElement.parentNode;
                    }while (targetElement);
                    event.preventDefault();
                } else if (event.type === "keyup") {
                    if (event.key !== "Escape") return;
                }
            }
            document.removeEventListener("click", this.close);
            document.removeEventListener("keyup", this.close);
            this.$btn.setAttribute("aria-expanded", "false");
            const st = window.getComputedStyle(this.$popupDisplay);
            if (st.transitionDelay !== "0s" || st.transitionDuration !== "0s") this.$popupDisplay.addEventListener('transitionend', (event)=>{
                this.$popupDisplay.setAttribute("hidden", true);
            }, {
                once: true
            });
            else this.$popupDisplay.setAttribute("hidden", true);
            this.$container.classList.remove("open");
        }
    }
    // Popup öffnen/schliessen
    toggle() {
        if (this.$container.classList.contains("open")) this.close();
        else this.open();
    }
}


class $fbae5fa1d8d96e27$export$b5d5cf8927ab7262 {
    constructor($ele){
        // Selektor-String
        if (typeof $ele !== "object") $ele = document.querySelector($ele);
        // Elemente
        this.$ele = $ele;
        this.$input = this.$ele.querySelector("input[type=hidden]");
        this.$container = this.$ele.closest(".switch-container");
        this.showIfOn = [];
        this.showIfOff = [];
        if (this.$container) {
            this.showIfOn = this.$container.querySelectorAll(".show-if-on");
            this.showIfOff = this.$container.querySelectorAll(".show-if-off");
        }
        // Event für Change
        this.eventChange = new CustomEvent('change', {
            detail: {
                switch: this
            }
        });
        // Acquisition
        this.#acquisition();
        // Klick-Aktion
        this.$ele.addEventListener('click', (event)=>{
            event.preventDefault();
            this.toggle();
        });
    }
    isActivated() {
        return this.$ele.getAttribute("aria-checked") === "true" ? true : false;
    }
    #acquisition() {
        // Anzeigebereiche ein- und ausblenden
        if (this.showIfOn) this.showIfOn.forEach(($e)=>{
            if (this.isActivated()) $e.classList.remove('hidden');
            else $e.classList.add('hidden');
        });
        if (this.showIfOff) this.showIfOff.forEach(($e)=>{
            if (this.isActivated()) $e.classList.add('hidden');
            else $e.classList.remove('hidden');
        });
        // Wert bei Input setzen
        if (this.$input) this.$input.value = this.isActivated();
    }
    toggle() {
        this.$ele.setAttribute("aria-checked", this.isActivated() ? false : true);
        this.#acquisition();
        this.$ele.dispatchEvent(this.eventChange);
    }
    undo() {
        this.$ele.setAttribute("aria-checked", this.isActivated() ? false : true);
        this.#acquisition();
    }
}







class $4375d2d61ae6c0ef$export$2b77a92f1a5ad772 {
    // Initialisieren
    constructor(selector){
        if (typeof selector === 'object') this.$ele = selector;
        else this.$ele = document.querySelector(selector);
    }
    // Einblenden
    show() {
        this.$ele.classList.remove('invisible');
        this.$ele.classList.remove('closed');
        // Focus auf erstes Eingabefeld oder Button setzen
        const $input = this.$ele.querySelector('input[type=text],input[type=email],input[type=url],input[type=tel],select,textarea');
        const $btn = this.$ele.querySelector('.btn-primary');
        if ($input) setTimeout(()=>{
            $input.focus();
        }, 300);
        else if ($btn) setTimeout(()=>{
            $btn.focus();
        }, 300);
    }
    // Ausblenden
    close() {
        this.$ele.classList.add('closed');
        setTimeout(()=>{
            this.$ele.classList.add('invisible');
        }, 300);
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(function() {
    // Klick-Event
    document.addEventListener('click', (event)=>{
        // Klicks zum Öffnen
        if (event.target && event.target.closest('*[data-modal-show]')) {
            const $btn = event.target.closest('*[data-modal-show]');
            const id = $btn.getAttribute('data-modal-show');
            if (id !== '') new $4375d2d61ae6c0ef$export$2b77a92f1a5ad772('#' + id).show();
        }
        // Klicks zum Schliessen
        if (event.target && event.target.closest('*[data-modal-close]')) {
            const $btn = event.target.closest('*[data-modal-close]');
            const id = $btn.getAttribute('data-modal-close');
            if (id === '' || id === null) {
                const $modal = $btn.closest('.modal');
                if ($modal !== null) new $4375d2d61ae6c0ef$export$2b77a92f1a5ad772($modal).close();
            } else if (id !== '') new $4375d2d61ae6c0ef$export$2b77a92f1a5ad772('#' + id).close();
        }
        // Klick auf Overlay
        if (event.target && event.target.matches('.overlay > div')) {
            const $modal = event.target.closest('.modal');
            if ($modal !== null && $modal.classList.contains("modal") && $modal.classList.contains("close-with-overlay")) new $4375d2d61ae6c0ef$export$2b77a92f1a5ad772($modal).close();
        }
    });
    // Esc-Taste zum Schliessen
    document.addEventListener("keyup", (event)=>{
        if (event.key === "Escape") {
            // Photoswipe-Ansicht ist geöffnet > Modals nicht schliessen
            if (document.querySelector(".pswp.pswp--open")) return;
            // Modals schliessen
            const modalClsEsc = document.querySelectorAll('.modal.close-with-esc');
            modalClsEsc.forEach(($modal)=>{
                if (!$modal.classList.contains('closed')) new $4375d2d61ae6c0ef$export$2b77a92f1a5ad772($modal).close();
            });
        }
    });
});


class $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd {
    constructor(){
        // HTML-Code für Notis
        this.html = `
<div>
    <div class="icon">
        <svg class="success" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <svg class="error" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
        </svg>
    </div>
    <div class="text">
        <p class="header"></p>
        <p></p>
    </div>
    <div class="btn">
        <button type="button" style="display:flex">
            <span>Dismiss</span>
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    </div>
</div>
`;
    }
    // Helper
    wait(time) {
        return new Promise((resolve)=>{
            return setTimeout(resolve, time * 1000);
        });
    }
    tick() {
        return new Promise((resolve)=>{
            return setTimeout(resolve, 10);
        });
    }
    blur() {
        let activeElement = undefined;
        if (document.activeElement) {
            activeElement = document.activeElement;
            document.activeElement.blur();
        }
        return activeElement;
    }
    generateRandomId() {
        const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            let r = Math.random() * 16 | 0;
            let v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
        return 'notie-' + id;
    }
    // Meldung entfernen
    removeFromDocument(id) {
        const element = document.getElementById(id);
        if (!element) return;
        if (element.listener) window.removeEventListener('keydown', element.listener);
        element.classList.add('closed');
        this.wait(0.3).then(()=>{
            if (element.parentNode) element.parentNode.removeChild(element);
        });
    }
    // Alle Meldungen ausblenden
    hideAll() {
        const notis = document.querySelectorAll('.notification');
        if (notis.length) notis.forEach(($noti)=>{
            this.removeFromDocument($noti.id);
        });
    }
    // Erfolgsmeldung anzeigen
    success(header, text = '', showCloseBtn = false, closeAfter = 6) {
        this.build(header, text, 'success', showCloseBtn, closeAfter);
    }
    // Fehlermeldung anzeigen
    error(header, text = '', showCloseBtn = true, closeAfter = 0) {
        this.build(header, text, 'error', showCloseBtn, closeAfter);
    }
    // Meldung erstellen
    build(header, text = '', type = '', showCloseBtn = true, closeAfter = 6) {
        this.hideAll();
        let element = document.createElement('div');
        const id = this.generateRandomId();
        element.id = id;
        element.classList.add('notification');
        element.classList.add('closed');
        element.innerHTML = this.html;
        // Inhalte einfügen
        const elHeader = element.querySelector('.text > p.header');
        const elText = element.querySelector('.text > p:last-child');
        const elBtn = element.querySelector('.btn');
        elHeader.innerHTML = header;
        elText.innerHTML = text;
        const svgs = element.querySelectorAll('.icon > svg');
        svgs.forEach(($svg)=>{
            $svg.style.display = 'none';
        });
        if (type != '') {
            element.classList.add(type);
            const svg = element.querySelector('.icon > svg.' + type);
            svg.style.display = '';
        }
        if (!showCloseBtn) elBtn.style.display = 'none';
        // in Markup einfügen
        element = document.body.appendChild(element);
        // Einblenden
        this.tick().then(()=>{
            element.classList.remove('closed');
        });
        // Schliessen mit Button
        if (showCloseBtn) {
            const lastActiveElement = this.blur();
            const btns = element.querySelectorAll('.btn button');
            btns.forEach(($btn)=>{
                $btn.addEventListener('click', (event)=>{
                    this.removeFromDocument(id);
                    if (lastActiveElement) lastActiveElement.focus();
                });
                $btn.focus();
            });
        }
        // Schliessen nach Zeit
        if (closeAfter > 0) this.wait(closeAfter).then(()=>{
            this.removeFromDocument(id);
        });
    }
}


class $8c22183067da1665$var$Upgrademodal {
    // Init
    constructor(){
        this.modal = null;
        this.$modal = null;
        this.successCallback = null;
        // Preise fürs Caching abrufen
        setTimeout(()=>{
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('membership', 'execute_price_caching')).then((response)=>{}).catch((error)=>{
                console.log("Preise-Cache konnte nicht per XHR geladen werden. " + error.message);
            });
        }, 2000);
    }
    // Modal öffnen
    open(successCallback, feature = '') {
        // Modal noch nicht vorhanden
        if (!this.modal) {
            this.#createModal(()=>{
                this.open(successCallback, feature);
            });
            return;
        }
        // Feature selektieren
        const $featuresListLi = this.$modal.querySelectorAll("ul.featureslist > li");
        if ($featuresListLi) $featuresListLi.forEach(($li)=>{
            $li.classList.remove("target");
            if (feature != '') {
                if ($li.classList.contains(feature)) $li.classList.add("target");
            }
        });
        // Callback übernehmen
        this.successCallback = successCallback;
        // Modal einblenden
        this.modal.show();
    }
    // Modal erstellen
    #createModal(callback) {
        // Markup holen
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('membership', 'get_upgrademodal')).then((response)=>{
            // HTML-Markup einfügen
            const template = document.createElement('template');
            template.innerHTML = response.markup.trim();
            this.$modal = template.content.firstElementChild;
            const $main = document.querySelector('main');
            if ($main) $main.insertAdjacentElement('afterend', this.$modal);
            // Handler registrieren
            // Klick auf Upgrade: Tarifwechsel
            const $btnPlanChange = this.$modal.querySelector("button.paddle-change");
            if ($btnPlanChange) $btnPlanChange.addEventListener('click', (event)=>{
                const $ele = event.currentTarget;
                // Button auf Ladestatus setzen
                $ele.classList.add('loading');
                $ele.setAttribute('disabled', true);
                // Sendedaten
                const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                const isYearly = frequencyValue == 'annually';
                let productId = 0;
                if (isYearly === "true") productId = parseInt($ele.getAttribute('data-productid-yearly'), 10);
                else productId = parseInt($ele.getAttribute('data-productid-monthly'), 10);
                const subscription_id = parseInt($ele.getAttribute('data-subscription-id'), 10);
                const account_id = parseInt($ele.getAttribute('data-account-id'), 10);
                // Tarifwechsel per Ajax vornehmen
                const data = new FormData();
                data.append('product_id', productId);
                data.append('subscription_id', subscription_id);
                data.append('account_id', account_id);
                new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('membership/change_paid_plan'), data).then((response)=>{
                    // Modal schliessen
                    this.modal.close();
                    // Modal mit Markup entfernen
                    setTimeout(()=>{
                        this.modal = null;
                        this.$modal.remove();
                        this.$modal = null;
                    }, 300);
                    // Success-Callback ausführen
                    if (this.successCallback) this.successCallback();
                }).catch((error)=>{
                    new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                }).finally(()=>{
                    // Button zurücksetzen
                    $ele.classList.remove('loading');
                    $ele.removeAttribute('disabled');
                });
            });
            // Klick auf Upgrade: Neukunde
            const $btnCheckout = this.$modal.querySelector("button.paddle-checkout");
            if ($btnCheckout) {
                // Paddle initialisieren
                Paddle.Setup({
                    vendor: 120516
                });
                $btnCheckout.addEventListener('click', (event)=>{
                    const $ele = event.currentTarget;
                    // Sendedaten
                    const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                    const isYearly = frequencyValue == 'annually';
                    let productId = 0;
                    if (isYearly) productId = parseInt($ele.getAttribute('data-productid-yearly'), 10);
                    else productId = parseInt($ele.getAttribute('data-productid-monthly'), 10);
                    const account_email = $ele.getAttribute('data-account-email');
                    const account_id = parseInt($ele.getAttribute('data-account-id'));
                    const locale = $ele.getAttribute('data-locale');
                    const title = $ele.getAttribute('data-title');
                    const plan = $ele.getAttribute('data-plan');
                    const passthrough = {};
                    passthrough.account_id = account_id;
                    passthrough.lang = locale ?? 'en';
                    const para = {
                        product: productId,
                        passthrough: JSON.stringify(passthrough),
                        allowQuantity: false,
                        locale: locale,
                        successCallback: (data)=>{
                            // Modal schliessen
                            this.modal.close();
                            // Modal mit Markup entfernen
                            setTimeout(()=>{
                                this.modal = null;
                                this.$modal.remove();
                                this.$modal = null;
                            }, 300);
                            // Success-Callback ausführen
                            if (this.successCallback) this.successCallback();
                        }
                    };
                    if (account_email) para.email = account_email;
                    if (title) para.title = title;
                    Paddle.Checkout.open(para);
                });
            }
            // Modal init
            this.modal = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)(this.$modal);
            // Callback
            callback();
        }).catch((error)=>{
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
        });
    }
}
var $8c22183067da1665$export$2e2bcd8739ae039 = new $8c22183067da1665$var$Upgrademodal();


var $4b6fe9457f608df7$exports = {};
!function(e, t) {
    t($4b6fe9457f608df7$exports);
}($4b6fe9457f608df7$exports, function(e) {
    "use strict";
    function t(e) {
        var n, r, a = new Error(e);
        return n = a, r = t.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(n, r) : n.__proto__ = r, a;
    }
    function n(e, n, r) {
        var a = n.slice(0, r).split(/\n/), i = a.length, s = a[i - 1].length + 1;
        throw t(e += " at line " + i + " col " + s + ":\n\n  " + n.split(/\n/)[i - 1] + "\n  " + Array(s).join(" ") + "^");
    }
    t.prototype = Object.create(Error.prototype, {
        name: {
            value: "Squirrelly Error",
            enumerable: !1
        }
    });
    var r = new Function("return this")().Promise, a = !1;
    try {
        a = new Function("return (async function(){}).constructor")();
    } catch (e) {
        if (!(e instanceof SyntaxError)) throw e;
    }
    function i(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }
    function s(e, t, n) {
        for(var r in t)i(t, r) && (null == t[r] || "object" != typeof t[r] || "storage" !== r && "prefixes" !== r || n ? e[r] = t[r] : e[r] = s({}, t[r]));
        return e;
    }
    var o = /^async +/, c = /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})*}|(?!\${)[^\\`])*`/g, l = /'(?:\\[\s\w"'\\`]|[^\n\r'\\])*?'/g, f = /"(?:\\[\s\w"'\\`]|[^\n\r"\\])*?"/g, u = /[.*+\-?^${}()|[\]\\]/g;
    function p(e) {
        return u.test(e) ? e.replace(u, "\\$&") : e;
    }
    function h(e, r) {
        r.rmWhitespace && (e = e.replace(/[\r\n]+/g, "\n").replace(/^\s+|\s+$/gm, "")), c.lastIndex = 0, l.lastIndex = 0, f.lastIndex = 0;
        var a = r.prefixes, i = [
            a.h,
            a.b,
            a.i,
            a.r,
            a.c,
            a.e
        ].reduce(function(e, t) {
            return e && t ? e + "|" + p(t) : t ? p(t) : e;
        }, ""), s = new RegExp("([|()]|=>)|('|\"|`|\\/\\*)|\\s*((\\/)?(-|_)?" + p(r.tags[1]) + ")", "g"), u = new RegExp("([^]*?)" + p(r.tags[0]) + "(-|_)?\\s*(" + i + ")?\\s*", "g"), h = 0, d = !1;
        function g(t, a) {
            var i, p = {
                f: []
            }, g = 0, v = "c";
            function m(t) {
                var a = e.slice(h, t), i = a.trim();
                if ("f" === v) "safe" === i ? p.raw = !0 : r.async && o.test(i) ? (i = i.replace(o, ""), p.f.push([
                    i,
                    "",
                    !0
                ])) : p.f.push([
                    i,
                    ""
                ]);
                else if ("fp" === v) p.f[p.f.length - 1][1] += i;
                else if ("err" === v) {
                    if (i) {
                        var s = a.search(/\S/);
                        n("invalid syntax", e, h + s);
                    }
                } else p[v] = i;
                h = t + 1;
            }
            for("h" === a || "b" === a || "c" === a ? v = "n" : "r" === a && (p.raw = !0, a = "i"), s.lastIndex = h; null !== (i = s.exec(e));){
                var y = i[1], x = i[2], b = i[3], w = i[4], S = i[5], F = i.index;
                if (y) "(" === y ? (0 === g && ("n" === v ? (m(F), v = "p") : "f" === v && (m(F), v = "fp")), g++) : ")" === y ? 0 === --g && "c" !== v && (m(F), v = "err") : 0 === g && "|" === y ? (m(F), v = "f") : "=>" === y && (m(F), h += 1, v = "res");
                else if (x) {
                    if ("/*" === x) {
                        var I = e.indexOf("*/", s.lastIndex);
                        -1 === I && n("unclosed comment", e, i.index), s.lastIndex = I + 2;
                    } else if ("'" === x) l.lastIndex = i.index, l.exec(e) ? s.lastIndex = l.lastIndex : n("unclosed string", e, i.index);
                    else if ('"' === x) f.lastIndex = i.index, f.exec(e) ? s.lastIndex = f.lastIndex : n("unclosed string", e, i.index);
                    else if ("`" === x) c.lastIndex = i.index, c.exec(e) ? s.lastIndex = c.lastIndex : n("unclosed string", e, i.index);
                } else if (b) return m(F), h = F + i[0].length, u.lastIndex = h, d = S, w && "h" === a && (a = "s"), p.t = a, p;
            }
            return n("unclosed tag", e, t), p;
        }
        var v = function i(s, c) {
            s.b = [], s.d = [];
            var l, f = !1, p = [];
            function v(e, t) {
                e && (e = function(e, t, n, r) {
                    var a, i;
                    return "string" == typeof t.autoTrim ? a = i = t.autoTrim : Array.isArray(t.autoTrim) && (a = t.autoTrim[1], i = t.autoTrim[0]), (n || !1 === n) && (a = n), (r || !1 === r) && (i = r), "slurp" === a && "slurp" === i ? e.trim() : ("_" === a || "slurp" === a ? e = String.prototype.trimLeft ? e.trimLeft() : e.replace(/^[\s\uFEFF\xA0]+/, "") : "-" !== a && "nl" !== a || (e = e.replace(/^(?:\n|\r|\r\n)/, "")), "_" === i || "slurp" === i ? e = String.prototype.trimRight ? e.trimRight() : e.replace(/[\s\uFEFF\xA0]+$/, "") : "-" !== i && "nl" !== i || (e = e.replace(/(?:\n|\r|\r\n)$/, "")), e);
                }(e, r, d, t), e && (e = e.replace(/\\|'/g, "\\$&").replace(/\r\n|\n|\r/g, "\\n"), p.push(e)));
            }
            for(; null !== (l = u.exec(e));){
                var m, y = l[1], x = l[2], b = l[3] || "";
                for(var w in a)if (a[w] === b) {
                    m = w;
                    break;
                }
                v(y, x), h = l.index + l[0].length, m || n("unrecognized tag type: " + b, e, h);
                var S = g(l.index, m), F = S.t;
                if ("h" === F) {
                    var I = S.n || "";
                    r.async && o.test(I) && (S.a = !0, S.n = I.replace(o, "")), S = i(S), p.push(S);
                } else if ("c" === F) {
                    if (s.n === S.n) return f ? (f.d = p, s.b.push(f)) : s.d = p, s;
                    n("Helper start and end don't match", e, l.index + l[0].length);
                } else if ("b" === F) {
                    f ? (f.d = p, s.b.push(f)) : s.d = p;
                    var R = S.n || "";
                    r.async && o.test(R) && (S.a = !0, S.n = R.replace(o, "")), f = S, p = [];
                } else if ("s" === F) {
                    var T = S.n || "";
                    r.async && o.test(T) && (S.a = !0, S.n = T.replace(o, "")), p.push(S);
                } else p.push(S);
            }
            if (!c) throw t('unclosed helper "' + s.n + '"');
            return v(e.slice(h, e.length), !1), s.d = p, s;
        }({
            f: []
        }, !0);
        if (r.plugins) for(var m = 0; m < r.plugins.length; m++){
            var y = r.plugins[m];
            y.processAST && (v.d = y.processAST(v.d, r));
        }
        return v.d;
    }
    function d(e, t) {
        var n = h(e, t), r = "var tR='';" + (t.useWith ? "with(" + t.varName + "||{}){" : "") + x(n, t) + "if(cb){cb(null,tR)} return tR" + (t.useWith ? "}" : "");
        if (t.plugins) for(var a = 0; a < t.plugins.length; a++){
            var i = t.plugins[a];
            i.processFnString && (r = i.processFnString(r, t));
        }
        return r;
    }
    function g(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n][0], a = t[n][1];
            e = (t[n][2] ? "await " : "") + "c.l('F','" + r + "')(" + e, a && (e += "," + a), e += ")";
        }
        return e;
    }
    function v(e, t, n, r, a, i) {
        var s = "{exec:" + (a ? "async " : "") + y(n, t, e) + ",params:[" + r + "]";
        return i && (s += ",name:'" + i + "'"), a && (s += ",async:true"), s += "}";
    }
    function m(e, t) {
        for(var n = "[", r = 0; r < e.length; r++){
            var a = e[r];
            n += v(t, a.res || "", a.d, a.p || "", a.a, a.n), r < e.length && (n += ",");
        }
        return n += "]";
    }
    function y(e, t, n) {
        return "function(" + t + "){var tR='';" + x(e, n) + "return tR}";
    }
    function x(e, t) {
        for(var n = 0, r = e.length, a = ""; n < r; n++){
            var i = e[n];
            if ("string" == typeof i) a += "tR+='" + i + "';";
            else {
                var s = i.t, o = i.c || "", c = i.f, l = i.n || "", f = i.p || "", u = i.res || "", p = i.b, h = !!i.a;
                if ("i" === s) {
                    t.defaultFilter && (o = "c.l('F'," + JSON.stringify(t.defaultFilter) + ")(" + o + ")");
                    var d = g(o, c);
                    !i.raw && t.autoEscape && (d = "c.l('F','e')(" + d + ")"), a += "tR+=" + d + ";";
                } else if ("h" === s) {
                    if (t.storage.nativeHelpers.get(l)) a += t.storage.nativeHelpers.get(l)(i, t);
                    else {
                        var y = (h ? "await " : "") + "c.l('H','" + l + "')(" + v(t, u, i.d, f, h);
                        y += p ? "," + m(p, t) : ",[]", a += "tR+=" + g(y += ",c)", c) + ";";
                    }
                } else "s" === s ? a += "tR+=" + g((h ? "await " : "") + "c.l('H','" + l + "')({params:[" + f + "]},[],c)", c) + ";" : "e" === s && (a += o + "\n");
            }
        }
        return a;
    }
    var b = function() {
        function e(e) {
            this.cache = e;
        }
        return e.prototype.define = function(e, t) {
            this.cache[e] = t;
        }, e.prototype.get = function(e) {
            return this.cache[e];
        }, e.prototype.remove = function(e) {
            delete this.cache[e];
        }, e.prototype.reset = function() {
            this.cache = {};
        }, e.prototype.load = function(e) {
            s(this.cache, e, !0);
        }, e;
    }();
    function w(e, n, r, a) {
        if (n && n.length > 0) throw t((a ? "Native" : "") + "Helper '" + e + "' doesn't accept blocks");
        if (r && r.length > 0) throw t((a ? "Native" : "") + "Helper '" + e + "' doesn't accept filters");
    }
    function S(e, t, n, r, a) {
        n(e[t], t).then(function(i) {
            r += i, t === e.length - 1 ? a(r) : S(e, t + 1, n, r, a);
        });
    }
    function F(e, t, n, r, a, i) {
        r(t[n], e[t[n]]).then(function(s) {
            a += s, n === t.length - 1 ? i(a) : F(e, t, n + 1, r, a, i);
        });
    }
    var I = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    function R(e) {
        return I[e];
    }
    var T = new b({}), _ = new b({
        each: function(e, t) {
            var n = "", r = e.params[0];
            if (w("each", t, !1), e.async) return new Promise(function(t) {
                S(r, 0, e.exec, n, t);
            });
            for(var a = 0; a < r.length; a++)n += e.exec(r[a], a);
            return n;
        },
        foreach: function(e, t) {
            var n = e.params[0];
            if (w("foreach", t, !1), e.async) return new Promise(function(t) {
                F(n, Object.keys(n), 0, e.exec, "", t);
            });
            var r = "";
            for(var a in n)i(n, a) && (r += e.exec(a, n[a]));
            return r;
        },
        include: function(e, n, r) {
            w("include", n, !1);
            var a = r.storage.templates.get(e.params[0]);
            if (!a) throw t('Could not fetch template "' + e.params[0] + '"');
            return a(e.params[1], r);
        },
        extends: function(e, n, r) {
            var a = e.params[1] || {};
            a.content = e.exec();
            for(var i = 0; i < n.length; i++){
                var s = n[i];
                a[s.name] = s.exec();
            }
            var o = r.storage.templates.get(e.params[0]);
            if (!o) throw t('Could not fetch template "' + e.params[0] + '"');
            return o(a, r);
        },
        useScope: function(e, t) {
            return w("useScope", t, !1), e.exec(e.params[0]);
        }
    }), E = new b({
        if: function(e, t) {
            w("if", !1, e.f, !0);
            var n = "if(" + e.p + "){" + x(e.d, t) + "}";
            if (e.b) for(var r = 0; r < e.b.length; r++){
                var a = e.b[r];
                "else" === a.n ? n += "else{" + x(a.d, t) + "}" : "elif" === a.n && (n += "else if(" + a.p + "){" + x(a.d, t) + "}");
            }
            return n;
        },
        try: function(e, n) {
            if (w("try", !1, e.f, !0), !e.b || 1 !== e.b.length || "catch" !== e.b[0].n) throw t("native helper 'try' only accepts 1 block, 'catch'");
            var r = "try{" + x(e.d, n) + "}", a = e.b[0];
            return r += "catch" + (a.res ? "(" + a.res + ")" : "") + "{" + x(a.d, n) + "}";
        },
        block: function(e, t) {
            return w("block", e.b, e.f, !0), "if(!" + t.varName + "[" + e.p + "]){tR+=(" + y(e.d, "", t) + ")()}else{tR+=" + t.varName + "[" + e.p + "]}";
        }
    }), N = new b({
        e: function(e) {
            var t = String(e);
            return /[&<>"']/.test(t) ? t.replace(/[&<>"']/g, R) : t;
        }
    }), O = {
        varName: "it",
        autoTrim: [
            !1,
            "nl"
        ],
        autoEscape: !0,
        defaultFilter: !1,
        tags: [
            "{{",
            "}}"
        ],
        l: function(e, n) {
            if ("H" === e) {
                var r = this.storage.helpers.get(n);
                if (r) return r;
                throw t("Can't find helper '" + n + "'");
            }
            if ("F" === e) {
                var a = this.storage.filters.get(n);
                if (a) return a;
                throw t("Can't find filter '" + n + "'");
            }
        },
        async: !1,
        storage: {
            helpers: _,
            nativeHelpers: E,
            filters: N,
            templates: T
        },
        prefixes: {
            h: "@",
            b: "#",
            i: "",
            r: "*",
            c: "/",
            e: "!"
        },
        cache: !1,
        plugins: [],
        useWith: !1
    };
    function $(e, t) {
        var n = {};
        return s(n, O), t && s(n, t), e && s(n, e), n.l.bind(n), n;
    }
    function j(e, n) {
        var r, i = $(n || {}), s = Function;
        if (i.async) {
            if (!a) throw t("This environment doesn't support async/await");
            s = a;
        }
        if (i.varName && !1 === (r = i.varName, /^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(r))) throw t("options.varName must be a valid JS identifier");
        try {
            return new s(i.varName, "c", "cb", d(e, i));
        } catch (n) {
            throw n instanceof SyntaxError ? t("Bad template syntax\n\n" + n.message + "\n" + Array(n.message.length + 1).join("=") + "\n" + d(e, i)) : n;
        }
    }
    function A(e, t) {
        var n;
        return t.cache && t.name && t.storage.templates.get(t.name) ? t.storage.templates.get(t.name) : (n = "function" == typeof e ? e : j(e, t), t.cache && t.name && t.storage.templates.define(t.name, n), n);
    }
    O.l.bind(O), e.compile = j, e.compileScope = x, e.compileScopeIntoFunction = y, e.compileToString = d, e.defaultConfig = O, e.filters = N, e.getConfig = $, e.helpers = _, e.nativeHelpers = E, e.parse = h, e.render = function(e, n, a, i) {
        var s = $(a || {});
        if (!s.async) return A(e, s)(n, s);
        if (!i) {
            if ("function" == typeof r) return new r(function(t, r) {
                try {
                    t(A(e, s)(n, s));
                } catch (e) {
                    r(e);
                }
            });
            throw t("Please provide a callback function, this env doesn't support Promises");
        }
        try {
            A(e, s)(n, s, i);
        } catch (e) {
            return i(e);
        }
    }, e.templates = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});



class $85ad013a94768a89$export$f2c57338dfba4648 {
    // Init
    constructor(){
        this.$popup = null;
        this.$btn = null;
        this.$cont = null;
        this.$emptyState = null;
        this.btnAnimation = null;
        this.intervalLoadEntries = null;
        this.tplNotifications = null;
        // DOM ready
        (0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
            // Elemente
            this.$popup = document.querySelector(".topbar .popup.notifications");
            if (!this.$popup) return;
            this.$btn = this.$popup.querySelector("#notifications-menu");
            this.$cont = this.$popup.querySelector(".popup-display .cont");
            this.$emptyState = this.$popup.querySelector(".popup-display .empty-state");
            // Klick auf Glocken-Button
            this.$btn.addEventListener("click", (event)=>{
                // Progressbars animieren
                this.#animateProgressbars();
            });
            // nach 1,5 Sek. Einträge laden
            setTimeout(()=>{
                this.loadEntries();
            }, 1500);
            // Template für Notifications
            const $tplNotifications = this.$cont.querySelector('#tpl_notifications');
            if ($tplNotifications) this.tplNotifications = $4b6fe9457f608df7$exports.compile($tplNotifications.innerHTML);
            // Link-Handler
            this.$cont.addEventListener('click', (event)=>{
                if (event.target) {
                    // Upgrade-Links
                    const $btn_upgrade = event.target.closest('a.upgrade');
                    if ($btn_upgrade) {
                        event.preventDefault();
                        // Notifications schliessen
                        window.Popups.forEach((popup)=>{
                            popup.close();
                        });
                        // Upgrade-Modal
                        const successMsg = $btn_upgrade.dataset.successmsg ?? '';
                        const upgradetype = $btn_upgrade.dataset.upgradetype ?? '';
                        (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                            // Erfolgsmeldung
                            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success("Upgrade", successMsg);
                            // Notifications neu laden
                            this.loadEntries();
                        }, upgradetype);
                    }
                    // Resend Account Activation Message
                    const $btn_resendactivation = event.target.closest('a.resend_accountactivation');
                    if ($btn_resendactivation) {
                        event.preventDefault();
                        // Notifications schliessen
                        window.Popups.forEach((popup)=>{
                            popup.close();
                        });
                        // Aktivierungmail neu senden
                        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('account', 'resendconfirmmail')).then((response)=>{
                            // Erfolgsmeldung
                            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.message_header, response.message_text);
                        }).catch((error)=>{
                            // Fehlermeldung
                            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                        });
                    }
                }
            });
        });
    }
    // Button-Animation abspielen
    #playBtnAnimation() {
        // läuft bereits
        if (this.btnAnimation) return;
        if (this.$btn) {
            const $img = this.$btn.querySelector("img");
            // Ensure proper transform behavior
            $img.style.transformBox = "fill-box";
            $img.style.transformOrigin = "50% 12%";
            $img.style.transform = "rotate(0deg)";
            // Animation ausführen
            this.btnAnimation = $img.animate([
                {
                    transform: "rotate(0deg)"
                },
                {
                    transform: "rotate(-20deg)"
                },
                {
                    transform: "rotate(20deg)"
                },
                {
                    transform: "rotate(-15deg)"
                },
                {
                    transform: "rotate(15deg)"
                },
                {
                    transform: "rotate(-15deg)"
                },
                {
                    transform: "rotate(10deg)"
                },
                {
                    transform: "rotate(-10deg)"
                },
                {
                    transform: "rotate(0deg)"
                }
            ], {
                duration: 1800,
                easing: "ease-out",
                iterations: 1
            });
            this.btnAnimation.onfinish = ()=>{
                $img.style.transform = "rotate(0deg)";
                this.btnAnimation = null;
            };
        }
    }
    // Progressbars animieren
    #animateProgressbars() {
        const progressbars = document.querySelectorAll(".topbar .popup.notifications .popup-display .progressbar");
        progressbars.forEach(($progressbar)=>{
            if ($progressbar.hasAttribute("data-percent")) {
                const percent = parseInt($progressbar.dataset.percent);
                const $bar = $progressbar.firstElementChild.firstElementChild;
                const $li = $progressbar.closest("li");
                let isWarning = $li.classList.contains("warning");
                // erst auf 0 setzen
                $bar.classList.add("notrans");
                $bar.style.width = "0%";
                $bar.style.backgroundColor = "#3B82F6";
                setTimeout(()=>{
                    // Zielwert
                    $bar.classList.remove("notrans");
                    $bar.style.width = percent + "%";
                    if (isWarning) $bar.style.backgroundColor = "#EF4444";
                }, 10);
            }
        });
    }
    // Laden der Einträge
    loadEntries() {
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('account', 'get_notifications')).then((response)=>{
            this.$btn.classList.remove("show-indicator");
            // Einträge geliefert
            if (response.notifications && response.notifications.length > 0) {
                this.$emptyState.classList.add("hidden");
                // Inhalt aus Template einfügen
                this.$cont.innerHTML = this.tplNotifications(response, $4b6fe9457f608df7$exports.defaultConfig);
                // Indicator?
                let showIndicator = false;
                response.notifications.forEach((notification)=>{
                    if (notification.show_indicator && notification.show_indicator == true) showIndicator = true;
                });
                if (showIndicator) {
                    this.$btn.classList.add("show-indicator");
                    this.#playBtnAnimation();
                }
                // Progressbars animieren wenn Notifications geöffnet
                if (this.$popup.classList.contains("open")) this.#animateProgressbars();
            } else this.$emptyState.classList.remove("hidden");
            // regelmässig neu laden
            if (this.intervalLoadEntries == null) this.intervalLoadEntries = setInterval(this.reloadEntries.bind(this), 30000); // 30 Sek.
        }).catch((error)=>{
            console.error(error.message);
        });
    }
    // Neuladen der Einträge
    reloadEntries() {
        // nur wenn Notifications nicht geöffnet sind
        if (!this.$popup.classList.contains("open")) this.loadEntries();
    }
}





class $d14555b8da1ef4bb$export$6955bcca4cd3539f {
    constructor(){
        // Elemente
        const $panelContainer = document.getElementById('panel-container');
        const $panelEmail = document.getElementById('panel-email');
        const $panelPassword = document.getElementById('panel-password');
        const $formEmail = $panelEmail.querySelector('form');
        const $formPassword = $panelPassword.querySelector('form');
        const $inputEmail = $formEmail.querySelector('input[name=email]');
        const $inputHiddenEmail = $formPassword.querySelector('input[name=email]');
        const $btnUserChange = $panelPassword.querySelector('a.change-user');
        const $btnPassreset = $panelPassword.querySelector('a.go-passreset');
        // Event: Absenden der Email-Adresse
        $formEmail.addEventListener('submit', (event)=>{
            event.preventDefault();
            const $form = event.currentTarget;
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($form);
            // Übermittlung
            const formData = new FormData($form);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('login'), formData).then((response)=>{
                // Email übernehmen
                const $emailStr = $formPassword.querySelector('div.email');
                $emailStr.textContent = $inputEmail.value;
                $inputHiddenEmail.value = $inputEmail.value;
                // Fehlermeldung ausblenden
                const $otherErrorbox = $formPassword.querySelector('.errorbox');
                $otherErrorbox.classList.add('hidden');
                // zur Passworteingabe
                $panelEmail.classList.add('hidden');
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelPassword, 'swoopInRight');
                $panelPassword.classList.remove('hidden');
            }).catch((error)=>{
                // kein Passwort hinterlegt > zur Erfassung
                if (error.message.substring(0, 11) == "no-password") (0, $bd2663108f285dbc$export$86fbec116b87613f).goto('account', 'setuppassword', error.message.substring(12));
                else {
                    const $errorbox = $panelEmail.querySelector('.errorbox');
                    const $cont = $errorbox.querySelector('.cont');
                    $cont.innerHTML = error.message;
                    (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($errorbox, 'pullUp');
                    $errorbox.classList.remove('hidden');
                    // Box schütteln
                    (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelContainer, 'shake');
                }
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($form);
            });
        });
        // Klick auf Neusendung von Freischaltungs-Mail
        document.addEventListener('click', (event)=>{
            if (event.target.matches('a.resend_accountactivation')) {
                event.preventDefault();
                // Aktivierungmail neu senden
                new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('account', 'resendconfirmmail', $inputEmail.value)).then((response)=>{
                    // Erfolgsmeldung
                    new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.message_header, response.message_text);
                    // Fehlermeldung ausblenden
                    const $errorbox = $panelEmail.querySelector('.errorbox');
                    $errorbox.classList.add('hidden');
                }).catch((error)=>{
                    // Fehlermeldung
                    new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                });
            }
        });
        // Event: Benutzer wechseln
        $btnUserChange.addEventListener('click', (event)=>{
            event.preventDefault();
            // Fehlermeldung ausblenden
            $panelEmail.querySelector('.errorbox').classList.add('hidden');
            // Email-Eingabe einblenden
            $panelPassword.classList.add('hidden');
            (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelEmail, 'swoopInLeft');
            $panelEmail.classList.remove('hidden');
        });
        // Event: Passwort vergessen
        $btnPassreset.addEventListener('click', (event)=>{
            event.preventDefault();
            let url = event.currentTarget.getAttribute('href');
            url += '?email=' + $inputHiddenEmail.value;
            (0, $bd2663108f285dbc$export$86fbec116b87613f).gotoUrl(url);
        });
        // Event: Anmeldung
        $formPassword.addEventListener('submit', (event)=>{
            event.preventDefault();
            const $form = event.currentTarget;
            const $errorbox = $form.querySelector('.errorbox');
            let go_path = '';
            const $inputGoPath = $panelPassword.querySelector('input[name=go_path]');
            if ($inputGoPath) go_path = $inputGoPath.value;
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($form);
            // Übermittlung
            const formData = new FormData($form);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('login'), formData).then((response)=>{
                // Weiterleitung zu Dashboard
                if (go_path == '') (0, $bd2663108f285dbc$export$86fbec116b87613f).goto();
                else (0, $bd2663108f285dbc$export$86fbec116b87613f).gotoUrl(window.location.protocol + "//" + window.location.hostname + "/" + go_path);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                $errorbox.querySelector('.cont').innerHTML = error.message;
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($errorbox, 'pullUp');
                $errorbox.classList.remove('hidden');
                // Box schütteln
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelContainer, 'shake');
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($form);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('login')) new $d14555b8da1ef4bb$export$6955bcca4cd3539f();
});





class $6495283adbbff537$export$6955bcca4cd3539f {
    constructor(){
        // Elemente
        this.$form = document.querySelector('form');
        this.$errorbox = document.querySelector('div.errorbox');
        this.$container = document.querySelector('div.conta');
        // Event: Absenden des Formulars
        this.$form.addEventListener('submit', (event)=>{
            event.preventDefault();
            var $form = event.currentTarget;
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($form);
            // Übermittlung
            const formData = new FormData($form);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('account', 'passreset'), formData).then((response)=>{
                // Fehlermeldung ausblenden
                this.$errorbox.classList.add('hidden');
                // Formular zurücksetzen
                $form.reset();
                // Erfolgsmeldung
                new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-sent').show();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                var $cont = this.$errorbox.querySelector('.cont');
                $cont.innerHTML = error.message;
                this.$errorbox.classList.remove('hidden');
                // Box schütteln
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS(this.$container, 'shake');
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($form);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('account-passreset')) new $6495283adbbff537$export$6955bcca4cd3539f();
});





class $1587b94c9a2e9e69$export$6955bcca4cd3539f {
    constructor(){
        // Elemente
        this.$form = document.querySelector('form');
        this.$errorbox = document.querySelector('div.errorbox');
        this.$container = document.querySelector('div.conta');
        // Event: Absenden des Formulars
        this.$form.addEventListener('submit', (event)=>{
            event.preventDefault();
            var $form = event.currentTarget;
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($form);
            // Übermittlung
            const formData = new FormData($form);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('account', 'passreset', $form.getAttribute('data-code')), formData).then((response)=>{
                // Fehlermeldung ausblenden
                this.$errorbox.classList.add('hidden');
                // Formular zurücksetzen
                $form.reset();
                // Erfolgsmeldung
                new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-sent').show();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                var $cont = this.$errorbox.querySelector('.cont');
                $cont.innerHTML = error.message;
                this.$errorbox.classList.remove('hidden');
                // Box schütteln
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS(this.$container, 'shake');
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($form);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('account-passreset-code')) new $1587b94c9a2e9e69$export$6955bcca4cd3539f();
});





class $f44a1bd93ad3098d$export$6955bcca4cd3539f {
    constructor(){
        // Elemente
        this.$form = document.querySelector('form');
        this.$errorbox = document.querySelector('div.errorbox');
        this.$container = document.querySelector('div.conta');
        // Event: Absenden des Formulars
        this.$form.addEventListener('submit', (event)=>{
            event.preventDefault();
            var $form = event.currentTarget;
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($form);
            // Übermittlung
            const formData = new FormData($form);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('account', 'register'), formData).then((response)=>{
                // Fehlermeldung ausblenden
                this.$errorbox.classList.add('hidden');
                // Formular zurücksetzen
                $form.reset();
                // Erfolgsmeldung
                new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-sent').show();
                // Ziel bei Matomo triggern
                _paq.push([
                    'trackGoal',
                    1
                ]);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                var $cont = this.$errorbox.querySelector('.cont');
                $cont.innerHTML = error.message;
                this.$errorbox.classList.remove('hidden');
                // Box schütteln
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS(this.$container, 'shake');
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($form);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('account-register')) new $f44a1bd93ad3098d$export$6955bcca4cd3539f();
});





class $d33e48484c5858b2$export$6955bcca4cd3539f {
    constructor(){
        // Elemente
        this.$form = document.querySelector('form');
        this.$errorbox = document.querySelector('div.errorbox');
        this.$container = document.querySelector('div.conta');
        // Event: Absenden des Formulars
        this.$form.addEventListener('submit', (event)=>{
            event.preventDefault();
            var $form = event.currentTarget;
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($form);
            // Übermittlung
            const formData = new FormData($form);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('account', 'setuppassword', $form.dataset.c), formData).then((response)=>{
                // Fehlermeldung ausblenden
                this.$errorbox.classList.add('hidden');
                // Formular zurücksetzen
                $form.reset();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg, '', false, 0);
                // Weiterleitung zum Panel
                setTimeout(()=>{
                    (0, $bd2663108f285dbc$export$86fbec116b87613f).goto('');
                }, "3000");
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                var $cont = this.$errorbox.querySelector('.cont');
                $cont.innerHTML = error.message;
                this.$errorbox.classList.remove('hidden');
                // Box schütteln
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS(this.$container, 'shake');
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($form);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('account_setuppassword')) new $d33e48484c5858b2$export$6955bcca4cd3539f();
});





var $bacf01ab4aec807d$var$t = function() {
    return $bacf01ab4aec807d$var$t = Object.assign || function(t) {
        for(var i, e = 1, s = arguments.length; e < s; e++)for(var n in i = arguments[e])Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        return t;
    }, $bacf01ab4aec807d$var$t.apply(this, arguments);
}, $bacf01ab4aec807d$export$1567cc001e3d0c1d = function() {
    function i(i, e, s) {
        var n = this;
        this.endVal = e, this.options = s, this.version = "2.10.1", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            autoAnimate: !1,
            autoAnimateDelay: 200,
            autoAnimateOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            n.startTime || (n.startTime = t);
            var i = t - n.startTime;
            n.remaining = n.duration - i, n.useEasing ? n.countDown ? n.frameVal = n.startVal - n.easingFn(i, 0, n.startVal - n.endVal, n.duration) : n.frameVal = n.easingFn(i, n.startVal, n.endVal - n.startVal, n.duration) : n.frameVal = n.startVal + (n.endVal - n.startVal) * (i / n.duration);
            var e = n.countDown ? n.frameVal < n.endVal : n.frameVal > n.endVal;
            n.frameVal = e ? n.endVal : n.frameVal, n.frameVal = Number(n.frameVal.toFixed(n.options.decimalPlaces)), n.printValue(n.frameVal), i < n.duration ? n.rAF = requestAnimationFrame(n.count) : null !== n.finalEndVal ? n.update(n.finalEndVal) : n.options.onCompleteCallback && n.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, e, s, a, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(n.options.decimalPlaces);
            var r = (i += "").split(".");
            if (e = r[0], s = r.length > 1 ? n.options.decimal + r[1] : "", n.options.useGrouping) {
                a = "";
                for(var l = 3, u = 0, h = 0, p = e.length; h < p; ++h)n.options.useIndianSeparators && 4 === h && (l = 2, u = 1), 0 !== h && u % l == 0 && (a = n.options.separator + a), u++, a = e[p - h - 1] + a;
                e = a;
            }
            return n.options.numerals && n.options.numerals.length && (e = e.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            })), o + n.options.prefix + e + s + n.options.suffix;
        }, this.easeOutExpo = function(t, i, e, s) {
            return e * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $bacf01ab4aec807d$var$t($bacf01ab4aec807d$var$t({}, this.defaults), s), this.options.enableScrollSpy && (this.options.autoAnimate = !0), void 0 !== this.options.scrollSpyDelay && (this.options.autoAnimateDelay = this.options.scrollSpyDelay), this.options.scrollSpyOnce && (this.options.autoAnimateOnce = !0), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = "string" == typeof i ? document.getElementById(i) : i, e = null == e ? this.parse(this.el.innerHTML) : e, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(e), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.autoAnimate && (this.error || "undefined" == typeof IntersectionObserver ? this.error ? console.error(this.error, i) : console.error("IntersectionObserver is not supported by this browser") : this.setupObserver());
    }
    return i.prototype.setupObserver = function() {
        var t = this, e = i.observedElements.get(this.el);
        e && e.unobserve(), i.observedElements.set(this.el, this), this.observer = new IntersectionObserver(function(i) {
            for(var e = 0, s = i; e < s.length; e++){
                var n = s[e];
                n.isIntersecting && t.paused && !t.once ? (t.paused = !1, t.autoAnimateTimeout = setTimeout(function() {
                    return t.start();
                }, t.options.autoAnimateDelay), t.options.autoAnimateOnce && (t.once = !0, t.observer.disconnect())) : n.isIntersecting || t.paused || (clearTimeout(t.autoAnimateTimeout), t.reset());
            }
        }, {
            threshold: 0
        }), this.observer.observe(this.el);
    }, i.prototype.unobserve = function() {
        var t;
        clearTimeout(this.autoAnimateTimeout), null === (t = this.observer) || void 0 === t || t.disconnect(), i.observedElements.delete(this.el);
    }, i.prototype.onDestroy = function() {
        clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = !0, this.unobserve(), this.options.onCompleteCallback = null, this.options.onStartCallback = null;
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = null !== this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var e = this.countDown ? 1 : -1;
            this.endVal = t + e * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        if (this.paused) this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count);
        else {
            cancelAnimationFrame(this.rAF);
            var t = null !== this.finalEndVal ? this.duration + this.remaining : this.remaining;
            this.remaining = t;
        }
        this.paused = !this.paused;
    }, i.prototype.reset = function() {
        clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = !0, this.once = !1, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var e = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, e);
            else if ("INPUT" === this.el.tagName) this.el.value = e;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = e : this.el.innerHTML = e;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i.prototype.parse = function(t) {
        var i = function(t) {
            return t.replace(/([.,'  ])/g, "\\$1");
        }, e = i(this.options.separator), s = i(this.options.decimal), n = t.replace(new RegExp(e, "g"), "").replace(new RegExp(s, "g"), ".");
        return parseFloat(n);
    }, i.observedElements = new WeakMap, i;
}();


class $77d6375792eb3230$export$6955bcca4cd3539f {
    constructor(){
        // CountUps
        let separator = ",";
        let decimal = ".";
        if ((0, $bd2663108f285dbc$export$86fbec116b87613f).getLang() == "de") {
            separator = ".";
            decimal = ",";
        }
        const countUpElements = document.querySelectorAll('span.count-up');
        countUpElements.forEach(($el)=>{
            let countUp = new (0, $bacf01ab4aec807d$export$1567cc001e3d0c1d)($el, $el.getAttribute('data-value'), {
                duration: 1,
                separator: separator,
                decimal: decimal
            });
            countUp.start();
        });
        // Fokus auf Button "Formular anlegen"
        if (document.querySelector("section.welcome")) {
            const $btn = document.querySelector("section.welcome .btn-primary");
            if ($btn) $btn.focus();
        }
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('dashboard')) new $77d6375792eb3230$export$6955bcca4cd3539f();
});



var $9b4756717f0aef41$exports = {};
$9b4756717f0aef41$exports = function(t) {
    var e = {};
    function r(n) {
        if (e[n]) return e[n].exports;
        var o = e[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = t, r.c = e, r.d = function(t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, r.t = function(t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var o in t)r.d(n, o, (function(e) {
            return t[e];
        }).bind(null, o));
        return n;
    }, r.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return r.d(e, "a", e), e;
    }, r.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 1);
}([
    function(t, e, r) {
        var n = r(2), o = r(3), i = r(4);
        t.exports = function(t) {
            return n(t) || o(t) || i();
        };
    },
    function(t, e, r) {
        "use strict";
        r.r(e), r.d(e, "sparkline", function() {
            return c;
        });
        var n = r(0), o = r.n(n);
        function i(t, e, r, n) {
            return parseFloat((e - n * e / t + r).toFixed(2));
        }
        function a(t) {
            return t.value;
        }
        function u(t, e) {
            var r = document.createElementNS("http://www.w3.org/2000/svg", t);
            for(var n in e)r.setAttribute(n, e[n]);
            return r;
        }
        function c(t, e, r) {
            var n;
            if (n = t, o()(n.querySelectorAll("*")).forEach(function(t) {
                return n.removeChild(t);
            }), !(e.length <= 1)) {
                r = r || {}, "number" == typeof e[0] && (e = e.map(function(t) {
                    return {
                        value: t
                    };
                }));
                var c = r.onmousemove, l = r.onmouseout, s = "interactive" in r ? r.interactive : !!c, f = r.spotRadius || 2, p = 2 * f, d = r.cursorWidth || 2, v = parseFloat(t.attributes["stroke-width"].value), b = r.fetch || a, h = e.map(function(t) {
                    return b(t);
                }), y = parseFloat(t.attributes.width.value) - 2 * p, x = parseFloat(t.attributes.height.value), m = x - 2 * v - p, g = Math.max.apply(Math, o()(h)), A = -1000, w = h.length - 1, j = y / w, O = [], k = i(g, m, v + f, h[0]), S = "M".concat(p, " ").concat(k);
                h.forEach(function(t, r) {
                    var n = r * j + p, o = i(g, m, v + f, t);
                    O.push(Object.assign({}, e[r], {
                        index: r,
                        x: n,
                        y: o
                    })), S += " L ".concat(n, " ").concat(o);
                });
                var M = u("path", {
                    class: "sparkline--line",
                    d: S,
                    fill: "none"
                }), C = u("path", {
                    class: "sparkline--fill",
                    d: "".concat(S, " V ").concat(x, " L ").concat(p, " ").concat(x, " Z"),
                    stroke: "none"
                });
                if (t.appendChild(C), t.appendChild(M), s) {
                    var E = u("line", {
                        class: "sparkline--cursor",
                        x1: A,
                        x2: A,
                        y1: 0,
                        y2: x,
                        "stroke-width": d
                    }), _ = u("circle", {
                        class: "sparkline--spot",
                        cx: A,
                        cy: A,
                        r: f
                    });
                    t.appendChild(E), t.appendChild(_);
                    var F = u("rect", {
                        width: t.attributes.width.value,
                        height: t.attributes.height.value,
                        style: "fill: transparent; stroke: transparent",
                        class: "sparkline--interaction-layer"
                    });
                    t.appendChild(F), F.addEventListener("mouseout", function(t) {
                        E.setAttribute("x1", A), E.setAttribute("x2", A), _.setAttribute("cx", A), l && l(t);
                    }), F.addEventListener("mousemove", function(t) {
                        var e = t.offsetX, r = O.find(function(t) {
                            return t.x >= e;
                        });
                        r || (r = O[w]);
                        var n, o = O[O.indexOf(r) - 1], i = (n = o ? o.x + (r.x - o.x) / 2 <= e ? r : o : r).x, a = n.y;
                        _.setAttribute("cx", i), _.setAttribute("cy", a), E.setAttribute("x1", i), E.setAttribute("x2", i), c && c(t, n);
                    });
                }
            }
        }
        e.default = c;
    },
    function(t, e) {
        t.exports = function(t) {
            if (Array.isArray(t)) {
                for(var e = 0, r = new Array(t.length); e < t.length; e++)r[e] = t[e];
                return r;
            }
        };
    },
    function(t, e) {
        t.exports = function(t) {
            if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
        };
    },
    function(t, e) {
        t.exports = function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        };
    }
]);





class $d1443ff491551608$export$6955bcca4cd3539f {
    constructor(){
        // Alle Sparkline initialisieren
        const $sparklines = document.querySelectorAll(".sparkline");
        function findClosest(target, tagName) {
            if (target.tagName === tagName) return target;
            while(target = target.parentNode){
                if (target.tagName === tagName) break;
            }
            return target;
        }
        $sparklines.forEach(($sparkline)=>{
            // const data = [
            //     { name: "Jänner 2025", value: 45 },
            //     { name: "Februar 2025", value: 34 },
            //     { name: "März 2025", value: 67 },
            //     { name: "April 2025", value: 34 },
            //     { name: "Mai 2025", value: 56 },
            //     { name: "Juni 2025", value: 34 },
            //     { name: "Juli 2025", value: 56 },
            // ];
            let data = [];
            const str = $sparkline.dataset.sparkline;
            const parts = str.split(';');
            parts.forEach((p)=>{
                const elements = p.split(':');
                data.push({
                    name: elements[0],
                    value: elements[1]
                });
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($9b4756717f0aef41$exports)))($sparkline, data, {
                onmousemove (event, datapoint) {
                    const $svg = findClosest(event.target, "svg");
                    const $tooltip = $svg.nextElementSibling;
                    $tooltip.hidden = false;
                    $tooltip.textContent = `${datapoint.name}: ${datapoint.value}`;
                    $tooltip.style.top = `${event.offsetY}px`;
                    $tooltip.style.left = `${event.offsetX + 20}px`;
                },
                onmouseout (event) {
                    const $svg = findClosest(event.target, "svg");
                    const $tooltip = $svg.nextElementSibling;
                    $tooltip.hidden = true;
                }
            });
        });
        // Klick auf Formular hinzufügen (Upgrade)
        const $btnAdd = document.querySelector("a.add");
        if ($btnAdd) $btnAdd.addEventListener('click', (event)=>{
            // Upgrade nötig
            if ($btnAdd.classList.contains("upgrade")) {
                event.preventDefault();
                const $ele = event.currentTarget;
                const successMsg = $ele.dataset.successmsg ?? '';
                (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                    // Erfolgsmeldung
                    new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success("Upgrade", successMsg);
                    // Upgrade-Klasse bei Button entfernen
                    $ele.classList.remove("upgrade");
                }, "forms");
            }
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('forms')) new $d1443ff491551608$export$6955bcca4cd3539f();
});







class $9cc26bef22bc9452$export$9497edad05e15c40 {
    // Initialisieren
    constructor(selector, storing = false, form_code = ''){
        // Hauptelement
        this.$ele = document.querySelector(selector);
        // direkte Speicherung
        this.storing = storing;
        this.form_code = form_code;
        // Vars
        this.id = this.$ele.getAttribute('id');
        this.modalAddSelector = '#' + this.id + ' .modal';
        // Elemente
        this.$list = this.$ele.querySelector('ul.list');
        this.$listLiEmpty = this.$list.querySelector('li.empty');
        this.$value = this.$ele.querySelector('input[type=hidden]');
        this.$btnAdd = this.$ele.querySelector('.cont button');
        this.$modalBtnApply = this.$ele.querySelector(this.modalAddSelector + ' button.apply');
        this.$modalError = this.$ele.querySelector(this.modalAddSelector + ' .error');
        this.modal = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)(this.modalAddSelector);
        // Öffnen des Modal
        this.$btnAdd.addEventListener('click', (event)=>{
            this.modal.show();
        });
        // Domain übernehmen
        this.$modalBtnApply.addEventListener('click', (event)=>{
            const $input = this.$ele.querySelector(this.modalAddSelector + ' input[type=text]');
            if ($input) this.addDomain($input.value);
        });
        this.updateList();
    }
    // Anzeige der Liste aktualisieren
    updateList() {
        // Liste der Domains
        const domains = this.getDomains();
        // vorhandene Einträge entfernen
        const entries = this.$list.querySelectorAll('li.entry');
        entries.forEach((el)=>{
            el.parentNode.removeChild(el);
        });
        // keine Domains gewählt
        if (domains.length === 0) this.$listLiEmpty.style.display = 'flex';
        else {
            this.$listLiEmpty.style.display = 'none';
            domains.forEach((address)=>{
                const element = document.createElement('li');
                element.classList.add('entry');
                let html = '';
                html += '    <div>';
                html += '        <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>';
                html += '        <span>' + address + '</span>';
                html += '    </div>';
                html += '    <div>';
                html += '        <button type="button">';
                html += '            <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24" class="h-5 w-5 inline"><path d="M6 18L18 6M6 6l12 12"></path></svg>';
                html += '        </button>';
                html += '    </div>';
                element.innerHTML = html;
                element.querySelector('button').addEventListener('click', (event)=>{
                    const $span = element.querySelector('span');
                    this.removeDomain($span.textContent);
                });
                this.$list.appendChild(element);
            });
        }
    }
    // liefert Liste der aktuelle gewählten Domains
    getDomains() {
        // Liste der Domains
        let domains = this.$value.value.split(",");
        domains.forEach((domain, i)=>{
            if (domain === "") domains.splice(i, 1);
        });
        return domains;
    }
    // Domain hinzufügen
    addDomain(domain) {
        // Fehler ausblenden
        this.$modalError.classList.add('hidden');
        // Eingabefeld
        const $input = this.$ele.querySelector(this.modalAddSelector + ' input[type=text]');
        // bei Fehler
        const error_function = (msg)=>{
            // Fehlermeldung anzeigen
            this.$modalError.querySelector('.cont').textContent = msg;
            this.$modalError.classList.remove('hidden');
            // Fokus auf Eingabe
            $input.focus();
        };
        // bei Erfolg
        const success_function = (add_domain)=>{
            // Eingabe leeren
            $input.value = '';
            // Hinzufügen
            let domains = this.getDomains();
            domains.push(add_domain);
            this.$value.value = domains.join(',');
            this.updateList();
            this.modal.close();
        };
        if (!this.storing) {
            // Ist bereits in Liste
            const domains = this.getDomains();
            if (domains.includes(domain)) {
                this.modal.close();
                return;
            }
            // Domain überprüfen
            const data = new FormData();
            data.append("domain", domain);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'validate_referrerdomain'), data).then((response)=>{
                if (response.domain) {
                    if (domains.includes(response.domain)) {
                        this.modal.close();
                        return;
                    }
                    success_function(response.domain);
                }
            }).catch((error)=>{
                error_function(error.message);
            });
        } else {
            // Domain eintragen
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("domain", domain);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'add_referrerdomain'), data).then((response)=>{
                console.log(response);
                if (response.domain) success_function(response.domain);
            }).catch((error)=>{
                error_function(error.message);
            });
        }
    }
    // Domain aus Liste entfernen
    removeDomain(domain) {
        // bei Erfolg
        const success_function = ()=>{
            const domains = this.getDomains();
            let newList = [];
            domains.forEach((a)=>{
                if (a !== domain) newList.push(a);
            });
            this.$value.value = newList.join(',');
            this.updateList();
        };
        if (!this.storing) success_function();
        else {
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("domain", domain);
            // Meldungen ausblenden
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'remove_referrerdomain'), data).then((response)=>{
                success_function();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
            });
        }
    }
}





class $2830db7cee9d5804$export$6955bcca4cd3539f {
    constructor(){
        // Vars
        this.current_step = 1;
        this.count_steps = 5;
        this.processors = [];
        // Elemente
        this.$btnBack = document.querySelector('button.go-back');
        this.$btnNext = document.querySelector('button.go-next');
        this.$btnSubmit = document.querySelector('button.submit');
        this.stepperEntries = document.querySelectorAll('nav.stepper li');
        this.stepperMobileEntries = document.querySelectorAll('nav.stepper-mobile li');
        this.$areaFormtemplate = document.querySelector('#area-formtemplate');
        this.radioFormContenttype = document.querySelectorAll('input[name="content-type"]');
        this.$form = document.querySelector('main form');
        this.$errorbox = this.$form.querySelector('.errorbox');
        this.$inputSiteUrl = this.$form.querySelector('input[name=site-url]');
        this.$langSelection = this.$form.querySelector('.lang-selection');
        this.radioNextPageType = document.querySelectorAll('input[name="next-page-type"]');
        this.$areaCustompage = document.querySelector('#area-custompage');
        this.$inputProcessors = this.$form.querySelector('input[name=processors]');
        this.$msgNoProcessor = this.$form.querySelector('.message.noprocessor');
        this.liProcessorsActive = this.$form.querySelectorAll('#list-processors > li');
        this.liProcessorsAdd = this.$form.querySelectorAll('#list-add-processors > li');
        // freigegebene Domains
        const referrerdomains = new (0, $9cc26bef22bc9452$export$9497edad05e15c40)('#referrerdomains');
        // Validierung der Formulareingaben
        const form_validate = (successCallback)=>{
            // Fehlermeldung ausblenden
            this.$errorbox.classList.add('hidden');
            // Validierungen
            const data = new FormData(this.$form);
            data.append("step", this.current_step);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'create_validate'), data).then((response)=>{
                successCallback();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorbox.querySelector('.cont').textContent = error.message;
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS(this.$errorbox, 'pullUp');
                this.$errorbox.classList.remove('hidden');
            }).finally(()=>{
                // Buttons zurücksetzen
                this.$btnNext.classList.remove('loading');
                this.$btnNext.removeAttribute('disabled');
                this.$btnSubmit.classList.remove('loading');
                this.$btnSubmit.removeAttribute('disabled');
            });
        };
        // Klick auf Navibuttons
        this.$btnBack.addEventListener('click', (event)=>{
            // Zurück
            if (this.current_step > 1) {
                --this.current_step;
                this.changeStepDisplay();
            }
        });
        this.$btnNext.addEventListener('click', (event)=>{
            // Button deaktivieren
            this.$btnNext.classList.add('loading');
            this.$btnNext.setAttribute('disabled', true);
            // Validierung ausführen
            form_validate(()=>{
                // bei Step 2: Website-Adresse in Domainbeschränkungen übernehmen
                const url = this.$inputSiteUrl.value;
                let domain = "";
                try {
                    domain = new URL(url).hostname;
                } catch (error) {
                    domain = "";
                }
                if (domain != "") referrerdomains.addDomain(domain);
                // Weiter
                ++this.current_step;
                this.changeStepDisplay();
                // Scroll to Top
                window.scrollTo(0, 80);
            });
        });
        this.$btnSubmit.addEventListener('click', (event)=>{
            // Button deaktivieren
            this.$btnSubmit.classList.add('loading');
            this.$btnSubmit.setAttribute('disabled', true);
            // Validierung ausführen
            form_validate(()=>{
                // Formular anlegen
                const dataSubmit = new FormData(this.$form);
                new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'create_submit'), dataSubmit).then((response)=>{
                    // Weiterleitung zur Integration
                    (0, $bd2663108f285dbc$export$86fbec116b87613f).goto('form', 'overview', response.form_code);
                }).catch((error)=>{
                    // Fehlermeldung anzeigen
                    this.$errorbox.querySelector('.cont').textContent = error.message;
                    (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS(this.$errorbox, 'pullUp');
                    this.$errorbox.classList.remove('hidden');
                }).finally(()=>{
                    // Buttons zurücksetzen
                    this.$btnSubmit.classList.remove('loading');
                    this.$btnSubmit.removeAttribute('disabled');
                });
            });
        });
        // zu Step springen
        if (this.stepperEntries.length > 0) this.stepperEntries.forEach(($step, stepIndex)=>{
            const $stepA = $step.querySelector('a');
            $stepA.addEventListener('click', (event)=>{
                event.preventDefault();
                // Aufruf nur möglich wenn complete
                if (!$step.classList.contains('complete')) return;
                // zu Schritt springen
                this.current_step = stepIndex + 1;
                this.changeStepDisplay();
            });
        });
        if (this.stepperMobileEntries.length > 0) this.stepperMobileEntries.forEach(($step, stepIndex)=>{
            const $stepA = $step.querySelector('a');
            $stepA.addEventListener('click', (event)=>{
                event.preventDefault();
                // Aufruf nur möglich wenn completed
                if (!$step.classList.contains('completed')) return;
                // zu Schritt springen
                this.current_step = stepIndex + 1;
                this.changeStepDisplay();
            });
        });
        // Schritt-Anzeige initialisieren
        this.changeStepDisplay();
        // Formular-Inhaltstyp-Auswahl
        this.radioFormContenttype.forEach((radio)=>{
            radio.addEventListener('change', (event)=>{
                const val = document.querySelector('input[name="content-type"]:checked').value;
                if (val == "template") this.$areaFormtemplate.classList.add("open");
                else this.$areaFormtemplate.classList.remove("open");
            });
        });
        // Sprach-Auswahl
        if (this.$langSelection) {
            const langInputs = this.$langSelection.querySelectorAll("input");
            langInputs.forEach(($langInput)=>{
                $langInput.addEventListener('change', (event)=>{
                    const $langLabel = $langInput.closest("label");
                    this.$langSelection.querySelectorAll("label").forEach(($l)=>{
                        $l.classList.remove('checked');
                    });
                    $langLabel.classList.add('checked');
                });
                if ($langInput.checked) $langInput.closest("label").classList.add('checked');
            });
        }
        // Prozessorauswahl
        this.processors = this.$inputProcessors.value.split(",");
        this.updateProcessorSelection();
        // Processor hinzufügen
        if (this.liProcessorsAdd) this.liProcessorsAdd.forEach(($li)=>{
            const $btnAdd = $li.querySelector('a.add');
            if ($btnAdd) $btnAdd.addEventListener('click', (event)=>{
                event.preventDefault();
                const processor_code = $li.dataset.processor;
                // Pro-Feature
                const isPro = event.target.classList.contains("pro") ? true : false;
                const proStatus = this.$form.dataset.isPro === "true" ? true : false;
                // Upgrade erforderlich
                if (isPro && !proStatus) {
                    // Upgrade
                    const successMsg = event.target.dataset.upgradeSuccessmsg ?? '';
                    let upgradeType = "";
                    if (processor_code == "Autoresponse") upgradeType = 'autoresponse';
                    else if (processor_code == "Whatsapp") upgradeType = 'whatsapp';
                    (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                        // Pro-Status vermerkten
                        this.$form.dataset.isPro = "true";
                        // Erfolgsmeldung
                        new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success("Upgrade", successMsg);
                        // Prozessor hinzufügen
                        this.addProcessor(processor_code);
                    }, upgradeType);
                } else this.addProcessor(processor_code);
            });
        });
        // Processor entfernen
        if (this.liProcessorsActive) this.liProcessorsActive.forEach(($li)=>{
            const $btnRemove = $li.querySelector('a.remove');
            if ($btnRemove) $btnRemove.addEventListener('click', (event)=>{
                const processor_code = $li.dataset.processor;
                const index = this.processors.indexOf(processor_code);
                if (index !== -1) this.processors.splice(index, 1);
                this.updateProcessorSelection();
            });
        });
        // Erfolgsseiten-Typ-Auswahl
        this.radioNextPageType.forEach((radio)=>{
            radio.addEventListener('change', (event)=>{
                const val = document.querySelector('input[name="next-page-type"]:checked').value;
                if (val == "custom") this.$areaCustompage.classList.add("open");
                else this.$areaCustompage.classList.remove("open");
            });
        });
    }
    addProcessor(processor_code) {
        if (!this.processors.includes(processor_code)) {
            // Hinzufügen
            this.processors.push(processor_code);
            // Anzeige aktualisieren
            this.updateProcessorSelection();
            // zu neuem Prozessor scrollen
            if (this.liProcessorsActive) this.liProcessorsActive.forEach(($l)=>{
                const p = $l.dataset.processor;
                if (p == processor_code) setTimeout(()=>{
                    $l.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 100);
            });
        }
    }
    updateProcessorSelection() {
        // Auswahl in Input übernehmen
        this.$inputProcessors.value = this.processors.join(',');
        // Aktive Prozessoren
        if (this.liProcessorsActive) this.liProcessorsActive.forEach(($li)=>{
            const processor_code = $li.dataset.processor;
            if (this.processors.includes(processor_code)) $li.classList.remove('hidden');
            else $li.classList.add('hidden');
        });
        // Auswahl zum Hinzufügen
        if (this.liProcessorsAdd) this.liProcessorsAdd.forEach(($li)=>{
            const processor_code = $li.dataset.processor;
            if (this.processors.includes(processor_code)) $li.classList.add('hidden');
            else $li.classList.remove('hidden');
        });
        // Meldung: kein Prozessor gewählt
        if (this.processors.length == 0) this.$msgNoProcessor.classList.remove('hidden');
        else this.$msgNoProcessor.classList.add('hidden');
    }
    changeStepDisplay() {
        // Fehlermeldung ausblenden
        this.$errorbox.classList.add('hidden');
        // Stepper aktualisieren
        if (this.stepperEntries.length > 0) this.stepperEntries.forEach(($entry, index)=>{
            let cl = "complete";
            if (index + 1 == this.current_step) cl = "current";
            else if (index + 1 > this.current_step) cl = "upcoming";
            $entry.classList.remove("complete", "current", "upcoming");
            $entry.classList.add(cl);
        });
        // Stepper-Mobile aktualisieren
        if (this.stepperMobileEntries.length > 0) this.stepperMobileEntries.forEach(($entry, index)=>{
            let cl = "completed";
            if (index + 1 == this.current_step) cl = "current";
            else if (index + 1 > this.current_step) cl = "upcoming";
            $entry.classList.remove("completed", "current", "upcoming");
            $entry.classList.add(cl);
        });
        // Beschriftung Stepper-Mobile aktualisieren
        const $step = document.querySelector('nav.stepper-mobile .currentStep');
        const $steps = document.querySelector('nav.stepper-mobile .countSteps');
        if ($step) $step.textContent = this.current_step;
        if ($steps) $steps.textContent = this.count_steps;
        // Submit-Button ein- ausblenden
        if (this.current_step === this.count_steps) this.$btnSubmit.style.display = "inline-flex";
        else this.$btnSubmit.style.display = "none";
        // Weiter-Button ein- und ausblenden
        if (this.current_step === this.count_steps) this.$btnNext.style.display = "none";
        else this.$btnNext.style.display = "inline-flex";
        // Zurück-Button de- aktivieren
        if (this.current_step == 1) this.$btnBack.setAttribute('disabled', true);
        else this.$btnBack.removeAttribute('disabled');
        // Bereich einblenden
        for(let n = 1; n <= this.count_steps; ++n){
            const $step = document.querySelector('#step' + n);
            if (n == this.current_step) $step.classList.add('current');
            else $step.classList.remove('current');
        }
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-create')) new $2830db7cee9d5804$export$6955bcca4cd3539f();
});





var $ab98ebfa6dd34a35$exports = {};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $ab98ebfa6dd34a35$exports = factory();
})($ab98ebfa6dd34a35$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command('cut');
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
                    var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS
                    fakeElement.style.fontSize = '12pt'; // Reset box model
                    fakeElement.style.border = '0';
                    fakeElement.style.padding = '0';
                    fakeElement.style.margin = '0'; // Move element out of screen horizontally
                    fakeElement.style.position = 'absolute';
                    fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute('readonly', '');
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command('copy');
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = '';
                    if (typeof target === 'string') selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        'text',
                        'search',
                        'url',
                        'tel',
                        'password'
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command('copy');
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? 'copy' : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== 'copy' && action !== 'cut') throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
                            if (action === 'copy' && target.hasAttribute('disabled')) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === 'cut' ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, 'click', function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || 'copy';
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? 'success' : 'error', {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue('action', trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue('target', trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue('text', trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    'copy',
                                    'cut'
                                ];
                                var actions = typeof action === 'string' ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== 'undefined' && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === 'function' && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === 'function') return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === 'function') // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === 'string') elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === 'string' || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === '[object Function]';
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error('Missing required arguments');
                    if (!is.string(type)) throw new TypeError('Second argument must be a String');
                    if (!is.fn(callback)) throw new TypeError('Third argument must be a Function');
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === 'SELECT') {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                        var isReadOnly = element.hasAttribute('readonly');
                        if (!isReadOnly) element.setAttribute('readonly', '');
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute('readonly');
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute('contenteditable')) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});


class $fa94579955056dac$export$6955bcca4cd3539f {
    constructor(){
        // Chart der Sendungen
        const $chart_submissions = document.querySelector("#chart-submissions");
        if ($chart_submissions) {
            let months_list = $chart_submissions.dataset?.monthsList;
            if (months_list) months_list = months_list.split(',');
            let months_subcounts = $chart_submissions.dataset?.monthsSubcounts;
            if (months_subcounts) months_subcounts = months_subcounts.split(',').map((num)=>parseInt(num));
            const locale_submissions = $chart_submissions.dataset?.localeSubmissions;
            const locales = [
                {
                    "name": "en",
                    "options": {
                        "months": [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        "shortMonths": [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        "days": [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        "shortDays": [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        "toolbar": {
                            "exportToSVG": "Download SVG",
                            "exportToPNG": "Download PNG",
                            "menu": "Menu",
                            "selection": "Selection",
                            "selectionZoom": "Selection Zoom",
                            "zoomIn": "Zoom In",
                            "zoomOut": "Zoom Out",
                            "pan": "Panning",
                            "reset": "Reset Zoom"
                        }
                    }
                },
                {
                    "name": "de",
                    "options": {
                        "months": [
                            "Januar",
                            "Februar",
                            "M\xe4rz",
                            "April",
                            "Mai",
                            "Juni",
                            "Juli",
                            "August",
                            "September",
                            "Oktober",
                            "November",
                            "Dezember"
                        ],
                        "shortMonths": [
                            "Jan",
                            "Feb",
                            "M\xe4r",
                            "Apr",
                            "Mai",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Okt",
                            "Nov",
                            "Dez"
                        ],
                        "days": [
                            "Sonntag",
                            "Montag",
                            "Dienstag",
                            "Mittwoch",
                            "Donnerstag",
                            "Freitag",
                            "Samstag"
                        ],
                        "shortDays": [
                            "So",
                            "Mo",
                            "Di",
                            "Mi",
                            "Do",
                            "Fr",
                            "Sa"
                        ],
                        "toolbar": {
                            "exportToSVG": "SVG herunterladen",
                            "exportToPNG": "PNG herunterladen",
                            "menu": "Men\xfc",
                            "selection": "Auswahl",
                            "selectionZoom": "Auswahl-Zoom",
                            "zoomIn": "Vergr\xf6\xdfern",
                            "zoomOut": "Verkleinern",
                            "pan": "Verschieben",
                            "reset": "Zoom zur\xfccksetzen"
                        }
                    }
                }
            ];
            if (months_list && months_subcounts) {
                const options = {
                    chart: {
                        type: 'line',
                        animations: {
                            enabled: true,
                            speed: 800
                        },
                        toolbar: {
                            show: false
                        },
                        foreColor: '#6B7280',
                        height: 230,
                        zoom: {
                            enabled: false
                        },
                        locales: locales,
                        defaultLocale: (0, $bd2663108f285dbc$export$86fbec116b87613f).getLang()
                    },
                    series: [
                        {
                            name: locale_submissions,
                            data: months_subcounts
                        }
                    ],
                    xaxis: {
                        categories: months_list,
                        type: 'category',
                        tooltip: {
                            enabled: false
                        }
                    },
                    legend: {
                        show: false
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3
                    },
                    colors: [
                        '#EC4899'
                    ],
                    dataLabels: {
                        enabled: false
                    },
                    tooltip: {
                        enabled: true,
                        enabledOnSeries: [
                            0
                        ],
                        x: {
                            show: false
                        },
                        y: {
                            formatter: undefined,
                            title: {
                                formatter: (seriesName)=>locale_submissions
                            }
                        },
                        marker: {
                            show: false
                        }
                    }
                };
                const chart = new ApexCharts($chart_submissions, options);
                chart.render();
            }
        }
        // CountUps
        let separator = ",";
        let decimal = ".";
        if ((0, $bd2663108f285dbc$export$86fbec116b87613f).getLang() == "de") {
            separator = ".";
            decimal = ",";
        }
        const countUpElements = document.querySelectorAll('span.count-up');
        countUpElements.forEach(($el)=>{
            const targetValue = parseInt($el.getAttribute('data-value'));
            let countUp = new (0, $bacf01ab4aec807d$export$1567cc001e3d0c1d)($el, targetValue, {
                duration: 0.8,
                separator: separator,
                decimal: decimal,
                startVal: 0
            });
            countUp.start();
        });
        // Kopierfunktion für Verbindungsdaten
        const btnsCopy = document.querySelectorAll("a.copy");
        btnsCopy.forEach(($btnCopy)=>{
            const templateClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnCopy, {
                text: function(trigger) {
                    const selectorStr = trigger.dataset.selectorId ?? null;
                    console.log(selectorStr);
                    if (selectorStr) {
                        const $ele = document.querySelector("#" + selectorStr);
                        if ($ele) {
                            let text = $ele.textContent.trim();
                            return text;
                        }
                    }
                }
            });
            templateClipboard.on('success', (event)=>{
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(msg);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-overview')) new $fa94579955056dac$export$6955bcca4cd3539f();
});








class $4f699e7788d9ec22$export$6955bcca4cd3539f {
    constructor(){
        // Vars
        this.current_page = 1;
        this.pages = 1;
        this.count_all = 0;
        this.spinnerSelector = '.tablearea .area-spinner';
        // Template für Tabellenzeilen
        this.tplTablerow = $4b6fe9457f608df7$exports.compile(document.getElementById('tpl_tablerow').innerHTML.replace(/=&gt;/g, '=>'));
        // Elemente
        this.$formCode = document.querySelector('header .form_code');
        this.$selectBox = document.getElementById('select_box');
        this.$actionsArea = document.querySelector('.actionsarea');
        this.$controlsAllActions = document.querySelector('.all_actions');
        this.$controlsSelectedActions = document.querySelector('.selected_actions');
        this.$exportAction = document.querySelector('#export-action');
        this.$selectedCounter = document.querySelectorAll('.selected_counter');
        this.$tableEmptyState = document.querySelector('.tablearea .empty-state');
        this.$tableWrapper = document.querySelector('.tablearea .tablewrapper');
        this.$selectAll = this.$tableWrapper.querySelector('thead input[type=checkbox]');
        this.$submissionsCounter = document.querySelector('.sub_counter');
        this.$submissionsStrSingle = document.querySelector('.sub_single');
        this.$submissionsStrPlural = document.querySelector('.sub_plural');
        this.$submissionsStrSpanInbox = document.querySelector('.sub_timespan_inbox');
        this.$submissionsStrSpanOther = document.querySelector('.sub_timespan_other');
        this.$submissionsUpgradeLink = document.querySelector('.sub_upgrade');
        this.$pagination = document.querySelector('nav.pagination');
        this.$paginationBtnBack = this.$pagination.querySelector('button.back');
        this.$paginationBtnNext = this.$pagination.querySelector('button.next');
        this.$paginationDesktop = this.$pagination.querySelector('.desktop');
        this.$paginationMobileSelect = document.getElementById('select_page');
        // Formular-Code
        this.form_code = this.$formCode.textContent;
        // Wechsel von Box
        this.$selectBox.addEventListener('change', (event)=>{
            this.loadList(1);
        });
        // Alle Zeilen an-/abwählen
        this.$selectAll.addEventListener('change', (event)=>{
            const checked = event.currentTarget.checked;
            const chkboxs = this.$tableWrapper.querySelectorAll('tbody input[type=checkbox]');
            if (chkboxs.length === 0) return;
            chkboxs.forEach((el)=>{
                el.checked = checked;
            });
            this.updateSelectedActions();
        });
        // Aktionen zu gewählten Zeilen
        let btns = this.$controlsSelectedActions.querySelectorAll('button.action');
        btns.forEach((el)=>{
            el.addEventListener('click', (event)=>{
                // Liste der gewählten Zeilen
                const selected = this.getSelectedIds();
                // Aktionen
                if (event.currentTarget.classList.contains('isspam')) this.moveTo('spam', selected);
                else if (event.currentTarget.classList.contains('nospam')) this.moveTo('inbox', selected);
                else if (event.currentTarget.classList.contains('delete')) this.moveTo('trash', selected);
                else if (event.currentTarget.classList.contains('undelete')) this.moveTo('inbox', selected);
                else if (event.currentTarget.classList.contains('deletefinally')) this.deleteFinally(selected);
            });
        });
        // Events bei Pagination
        this.$paginationBtnBack.addEventListener('click', (event)=>{
            this.loadList(this.current_page - 1);
        });
        this.$paginationBtnNext.addEventListener('click', (event)=>{
            this.loadList(this.current_page + 1);
        });
        this.$paginationMobileSelect.addEventListener('change', (event)=>{
            this.loadList(event.currentTarget.value);
        });
        // Upgrade-Link im Footer
        if (this.$submissionsUpgradeLink) {
            const $btnUpgrade = this.$submissionsUpgradeLink.querySelector('a.upgrade');
            $btnUpgrade.addEventListener('click', (event)=>{
                event.preventDefault();
                const $ele = event.currentTarget;
                const successMsg = $ele.dataset.successmsg ?? '';
                (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                    // Erfolgsmeldung
                    new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success("Upgrade", successMsg);
                    // Liste neu laden
                    this.loadList();
                    // Upgrade-Link aus DOM entfernen
                    this.$submissionsUpgradeLink.remove();
                }, "archive");
            });
        }
        // Liste laden
        this.loadList();
    }
    loadList(page = 0) {
        let scrollToTop = false;
        const data = new FormData();
        data.append("form_code", this.form_code);
        if (page > 0) {
            data.append("box", this.$selectBox.value);
            data.append("page", page);
            scrollToTop = true;
        }
        // Ladespinner anzeigen
        (0, $bd2663108f285dbc$export$86fbec116b87613f).showSpinnerArea(this.spinnerSelector);
        // Export-Funktion ausblenden wenn nicht Inbox
        if (this.$selectBox.value == 'inbox') this.$exportAction.classList.remove("hidden");
        else this.$exportAction.classList.add("hidden");
        // Laden
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'submissions_load'), data).then((response)=>{
            // Daten übernehmen
            this.current_page = parseInt(response.page);
            this.pages = parseInt(response.pages);
            this.count_all = parseInt(response.count_all);
            const allowedBoxes = [
                'inbox',
                'spam',
                'trash'
            ];
            if (response?.box === undefined || !allowedBoxes.includes(response.box)) response.box = 'inbox';
            this.$selectBox.value = response.box;
            // Aktionen für ausgewählte Einträge aktualisieren
            this.$controlsSelectedActions.querySelectorAll('button.action').forEach((el)=>{
                el.classList.add('hidden');
            });
            if (this.$selectBox.value == 'inbox') {
                this.$controlsSelectedActions.querySelectorAll('button.isspam, button.delete').forEach((el)=>{
                    el.classList.remove('hidden');
                });
                if (this.$submissionsUpgradeLink) this.$submissionsUpgradeLink.classList.add("show");
            } else if (this.$selectBox.value == 'spam') {
                this.$controlsSelectedActions.querySelectorAll('button.nospam').forEach((el)=>{
                    el.classList.remove('hidden');
                });
                if (this.$submissionsUpgradeLink) this.$submissionsUpgradeLink.classList.remove("show");
            } else if (this.$selectBox.value == 'trash') {
                this.$controlsSelectedActions.querySelectorAll('button.undelete').forEach((el)=>{
                    el.classList.remove('hidden');
                });
                this.$controlsSelectedActions.querySelectorAll('button.deletefinally').forEach((el)=>{
                    el.classList.remove('hidden');
                });
                if (this.$submissionsUpgradeLink) this.$submissionsUpgradeLink.classList.remove("show");
            }
            // Sendungszähler anzeigen
            this.$submissionsCounter.textContent = this.count_all.toLocaleString((0, $bd2663108f285dbc$export$86fbec116b87613f).getLang());
            if (this.count_all == 1) {
                this.$submissionsStrSingle.classList.remove('hidden');
                this.$submissionsStrPlural.classList.add('hidden');
            } else {
                this.$submissionsStrSingle.classList.add('hidden');
                this.$submissionsStrPlural.classList.remove('hidden');
            }
            // Zeitspanne anzeigen
            if (this.$selectBox.value == 'inbox') {
                this.$submissionsStrSpanInbox.classList.remove('hidden');
                this.$submissionsStrSpanOther.classList.add('hidden');
            } else {
                this.$submissionsStrSpanOther.classList.remove('hidden');
                this.$submissionsStrSpanInbox.classList.add('hidden');
            }
            // Pagination rendern
            if (this.current_page == 1) this.$paginationBtnBack.setAttribute('disabled', 'true');
            else this.$paginationBtnBack.removeAttribute('disabled');
            if (this.current_page == this.pages) this.$paginationBtnNext.setAttribute('disabled', 'true');
            else this.$paginationBtnNext.removeAttribute('disabled');
            let html = '';
            if (this.current_page > 4) {
                html += '<button type="button" class="page">1</button>';
                html += '<span class="spacing">...</span>';
                html += '<button type="button" class="page">' + (this.current_page - 1) + '</button>';
                html += '<button type="button" class="page current">' + this.current_page + '</button>';
            } else {
                for(let p = 1; p < this.current_page; ++p)html += '<button type="button" class="page">' + p + '</button>';
                html += '<button type="button" class="page current">' + this.current_page + '</button>';
            }
            const rest = this.pages - this.current_page;
            if (rest > 3) {
                html += '<button type="button" class="page">' + (this.current_page + 1) + '</button>';
                html += '<span class="spacing">...</span>';
                html += '<button type="button" class="page">' + this.pages + '</button>';
            } else for(let p = this.current_page + 1; p <= this.pages; ++p)html += '<button type="button" class="page">' + p + '</button>';
            this.$paginationDesktop.innerHTML = html;
            this.$paginationDesktop.querySelectorAll('button.page').forEach((el)=>{
                el.addEventListener('click', (event)=>{
                    this.loadList(parseInt(event.currentTarget.textContent));
                });
            });
            html = '';
            for(let p = 1; p <= this.pages; ++p)if (p == this.current_page) html += '<option value="' + p + '" selected>' + p + '</option>';
            else html += '<option value="' + p + '">' + p + '</option>';
            this.$paginationMobileSelect.innerHTML = html;
            // keine Sendungen
            if (this.count_all == 0) {
                this.$tableEmptyState.classList.remove('hidden');
                this.$tableWrapper.classList.add('hidden');
                this.$actionsArea.classList.add('hidden');
            } else {
                // Liste rendern
                const $tbody = this.$tableWrapper.querySelector('tbody');
                html = '';
                response.list.forEach((data)=>{
                    html += this.tplTablerow(data, $4b6fe9457f608df7$exports.defaultConfig);
                });
                $tbody.innerHTML = html;
                // Event: Auswahl von Zeile
                $tbody.querySelectorAll('input[type=checkbox]').forEach((el)=>{
                    el.addEventListener('click', (event)=>{
                        this.updateSelectedActions();
                    });
                });
                // Events: Aktionen
                $tbody.querySelectorAll('button.action').forEach((el)=>{
                    el.addEventListener('click', (event)=>{
                        // ID der Sendung
                        const $tr = event.currentTarget.closest('tr');
                        const id = parseInt($tr.getAttribute('data-id'));
                        // Aktionen
                        if (event.currentTarget.classList.contains('isspam')) this.moveTo('spam', [
                            id
                        ]);
                        else if (event.currentTarget.classList.contains('nospam')) this.moveTo('inbox', [
                            id
                        ]);
                        else if (event.currentTarget.classList.contains('delete')) this.moveTo('trash', [
                            id
                        ]);
                        else if (event.currentTarget.classList.contains('undelete')) this.moveTo('inbox', [
                            id
                        ]);
                        else if (event.currentTarget.classList.contains('deletefinally')) this.deleteFinally([
                            id
                        ]);
                    });
                });
                // Aktionen-Popup initialisieren
                const popups = $tbody.querySelectorAll(".popup");
                popups.forEach(($ele)=>{
                    const p = new (0, $d19f7743c2a8a520$export$129a32eedafa97c5)($ele, (instance)=>{
                        window.Popups.forEach((po)=>{
                            if (po !== instance) po.close();
                        });
                    });
                    window.Popups.push(p);
                });
                // Ein-/Ausblenden
                this.$tableEmptyState.classList.add('hidden');
                this.$tableWrapper.classList.remove('hidden');
                this.$actionsArea.classList.remove('hidden');
                this.$selectAll.checked = false;
                this.updateSelectedActions();
                // nach oben scrollen
                if (scrollToTop) document.querySelector('main').scrollIntoView({
                    behavior: 'auto',
                    block: 'start'
                });
            }
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error('Error during loading!', error.message);
        }).finally(()=>{
            // Ladespinner ausblenden
            (0, $bd2663108f285dbc$export$86fbec116b87613f).hideSpinnerArea(this.spinnerSelector);
        });
    }
    reloadList() {
        this.loadList(this.current_page);
    }
    getSelectedIds() {
        let ids = [];
        this.$tableWrapper.querySelectorAll('tbody input[type=checkbox]:checked').forEach((el)=>{
            const $tr = el.closest('tr');
            ids.push(parseInt($tr.getAttribute('data-id')));
        });
        return ids;
    }
    updateSelectedActions() {
        // ausgewählte IDs
        const selected = this.getSelectedIds();
        const count = selected.length;
        // Zähleranzeige
        this.$selectedCounter.forEach((el)=>{
            el.textContent = count;
        });
        // keine gewählt
        if (count === 0) {
            this.$controlsAllActions.classList.remove('hidden');
            this.$controlsSelectedActions.classList.add('hidden');
        } else {
            this.$controlsAllActions.classList.add('hidden');
            this.$controlsSelectedActions.classList.remove('hidden');
        }
    }
    moveTo(toBox, ids) {
        var data = new FormData();
        data.append("form_code", this.form_code);
        data.append("box", toBox);
        data.append("sub_ids", ids.join());
        // Meldungen ausblenden
        new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
        // Senden
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'submissions_move'), data).then((response)=>{
            // Erfolgsmeldung
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            // Liste neu laden
            this.reloadList();
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error('Error', error.message);
        });
    }
    deleteFinally(ids) {
        var data = new FormData();
        data.append("sub_ids", ids.join());
        // Meldungen ausblenden
        new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
        // Senden
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'submissions_deletefinally'), data).then((response)=>{
            // Erfolgsmeldung
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            // Liste neu laden
            this.reloadList();
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error('Error', error.message);
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-submissions')) new $4f699e7788d9ec22$export$6955bcca4cd3539f();
});







class $610f29ce82db1830$export$6955bcca4cd3539f {
    constructor(){
        // Elemente
        this.$formCode = document.querySelector('header .form_code');
        this.$submissionView = document.querySelector('#submission_view');
        this.menuActions = document.querySelectorAll('button.action');
        // Formular-Code
        this.form_code = this.$formCode.textContent;
        // Aktionen im Aktions-Menü ein- und ausblenden
        this.displayMenuActions();
        // Events: Aktions-Menü
        this.menuActions.forEach((el)=>{
            el.addEventListener('click', (event)=>{
                // ID der Sendung
                const id = parseInt(this.$submissionView.dataset.id);
                // Aktionen
                if (el.classList.contains('isspam')) this.moveTo('spam', [
                    id
                ]);
                else if (el.classList.contains('nospam')) this.moveTo('inbox', [
                    id
                ]);
                else if (el.classList.contains('delete')) this.moveTo('trash', [
                    id
                ]);
                else if (el.classList.contains('undelete')) this.moveTo('inbox', [
                    id
                ]);
                else if (el.classList.contains('deletefinally')) this.deleteFinally([
                    id
                ]);
            });
        });
        // Upgrade-Links
        const btnsUpgrade = document.querySelectorAll('main a.upgrade');
        btnsUpgrade.forEach(($btn)=>{
            $btn.addEventListener('click', (event)=>{
                event.preventDefault();
                const $ele = event.currentTarget;
                const upgradetype = $ele.dataset.upgradetype ?? '';
                (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                    // Seite neu laden
                    window.location.reload();
                }, upgradetype);
            });
        });
    }
    displayMenuActions() {
        const currentBox = this.$submissionView.dataset.box;
        this.menuActions.forEach((el)=>{
            if (el.classList.contains('isspam')) {
                if (currentBox == "inbox") el.classList.remove('hidden');
                else el.classList.add('hidden');
            } else if (el.classList.contains('nospam')) {
                if (currentBox == "spam") el.classList.remove('hidden');
                else el.classList.add('hidden');
            } else if (el.classList.contains('delete')) {
                if (currentBox == "inbox") el.classList.remove('hidden');
                else el.classList.add('hidden');
            } else if (el.classList.contains('undelete')) {
                if (currentBox == "trash") el.classList.remove('hidden');
                else el.classList.add('hidden');
            } else if (el.classList.contains('deletefinally')) {
                if (currentBox == "trash") el.classList.remove('hidden');
                else el.classList.add('hidden');
            }
        });
    }
    moveTo(toBox, ids) {
        var data = new FormData();
        data.append("form_code", this.form_code);
        data.append("box", toBox);
        data.append("sub_ids", ids.join());
        // Meldungen ausblenden
        new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
        // Senden
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'submissions_move'), data).then((response)=>{
            // Erfolgsmeldung
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            // Box übernehmen
            this.$submissionView.dataset.box = toBox;
            this.displayMenuActions();
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error('Error', error.message);
        });
    }
    deleteFinally(ids) {
        var data = new FormData();
        data.append("sub_ids", ids.join());
        // Meldungen ausblenden
        new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
        // Senden
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'submissions_deletefinally'), data).then((response)=>{
            // Erfolgsmeldung
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            // nach 1 Sek. zur Sendungsliste
            setTimeout(()=>{
                (0, $bd2663108f285dbc$export$86fbec116b87613f).goto('form', 'submissions', this.form_code);
            }, 1000);
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error('Error', error.message);
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-submission')) new $610f29ce82db1830$export$6955bcca4cd3539f();
});





class $e42c0cd489a52c83$export$6955bcca4cd3539f {
    constructor(){
        // Kopierfunktion für quellcode des Formulartemplates
        const $btnCopy = document.querySelector("#formtemplate_sourcecode button.copy");
        if ($btnCopy) {
            const templateClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnCopy, {
                text: function(trigger) {
                    const $code = document.querySelector("#formtemplate_sourcecode pre > code");
                    let text = $code.textContent.trim();
                    return text;
                }
            });
            templateClipboard.on('success', (event)=>{
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(msg);
            });
        }
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-integration')) new $e42c0cd489a52c83$export$6955bcca4cd3539f();
});







class $ae3ac94ca8b409fc$export$6955bcca4cd3539f {
    constructor(){
        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;
        // --- Formulartitel
        // Elemente
        this.$btnEditTitle = document.querySelector('button.title');
        this.$inputEditTitle = document.querySelector('#modal-edit-title input[name=title]');
        this.$displayTitle = document.querySelector('#value_title');
        this.$formEditTitle = document.querySelector('#modal-edit-title form');
        this.$errorboxEditTitle = document.querySelector('#modal-edit-title .errorbox');
        // Modal
        this.modalEditTitle = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-title');
        // Modaldialog öffnen
        this.$btnEditTitle.addEventListener('click', (event)=>{
            // aktuellen Titel in Eingabe übernehmen
            this.$inputEditTitle.value = this.$displayTitle.textContent;
            // Fehlermeldung ausblenden
            this.$errorboxEditTitle.classList.add('hidden');
            // Modal öffnen
            this.modalEditTitle.show();
        });
        // Speicherung
        this.$formEditTitle.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("title", this.$inputEditTitle.value);
            // Fehler ausblenden
            this.$errorboxEditTitle.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_formtitle'), data).then((response)=>{
                // Modal schliessen
                this.modalEditTitle.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayTitle.textContent = this.$inputEditTitle.value;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditTitle.querySelector('.cont').textContent = error.message;
                this.$errorboxEditTitle.classList.remove('hidden');
                // Fokus auf Eingabe
                this.$inputEditTitle.focus();
            });
        });
        // --- Website-Adresse
        // Elemente
        this.$btnEditSiteurl = document.querySelector('button.siteurl');
        this.$inputEditSiteurl = document.querySelector('#modal-edit-siteurl input[name=site_url]');
        this.$displaySiteurl = document.querySelector('#value_siteurl');
        this.$displaySiteurlEmpty = document.querySelector('#value_siteurl_empty');
        this.$formEditSiteurl = document.querySelector('#modal-edit-siteurl form');
        this.$errorboxEditSiteurl = document.querySelector('#modal-edit-siteurl .errorbox');
        // Modal
        this.modalEditSiteurl = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-siteurl');
        // Modaldialog öffnen
        this.$btnEditSiteurl.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditSiteurl.classList.add('hidden');
            // Modal öffnen
            this.modalEditSiteurl.show();
        });
        // Speicherung
        this.$formEditSiteurl.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("site_url", this.$inputEditSiteurl.value);
            // Fehler ausblenden
            this.$errorboxEditSiteurl.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_siteurl'), data).then((response)=>{
                // Modal schliessen
                this.modalEditSiteurl.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                if (response.site_url_view == '') {
                    this.$displaySiteurl.classList.add('hidden');
                    this.$displaySiteurlEmpty.classList.remove('hidden');
                } else {
                    this.$displaySiteurl.classList.remove('hidden');
                    this.$displaySiteurlEmpty.classList.add('hidden');
                    this.$displaySiteurl.textContent = response.site_url_view;
                }
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditSiteurl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditSiteurl.classList.remove('hidden');
                // Fokus auf Eingabe
                this.$inputEditSiteurl.focus();
            });
        });
        // --- Erfolgsseite
        // Elemente
        this.$btnEditNexturl = document.querySelector('button.nexturl');
        this.$inputEditNexturl = document.querySelector('#modal-edit-nexturl input[name=returnaddress]');
        this.$displayNexturl = document.querySelector('#value_nexturl');
        this.$displayNexturlEmpty = document.querySelector('#value_nexturl_empty');
        this.$formEditNexturl = document.querySelector('#modal-edit-nexturl form');
        this.$errorboxEditNexturl = document.querySelector('#modal-edit-nexturl .errorbox');
        // Modal
        this.modalEditNexturl = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-nexturl');
        // Modaldialog öffnen
        this.$btnEditNexturl.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditNexturl.classList.add('hidden');
            // Modal öffnen
            this.modalEditNexturl.show();
        });
        // Speicherung
        this.$formEditNexturl.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("next_url", this.$inputEditNexturl.value);
            // Fehler ausblenden
            this.$errorboxEditNexturl.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_nexturl'), data).then((response)=>{
                // Modal schliessen
                this.modalEditNexturl.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                if (response.next_url_view == '') {
                    this.$displayNexturl.classList.add('hidden');
                    this.$displayNexturlEmpty.classList.remove('hidden');
                } else {
                    this.$displayNexturl.classList.remove('hidden');
                    this.$displayNexturlEmpty.classList.add('hidden');
                    this.$displayNexturl.textContent = response.next_url_view;
                }
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditNexturl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditNexturl.classList.remove('hidden');
                // Fokus auf Eingabe
                this.$inputEditNexturl.focus();
            });
        });
        // --- Sprache
        // Elemente
        this.$btnEditLang = document.querySelector('button.lang');
        this.$inputEditLang = document.querySelector('#modal-edit-lang select[name=lang]');
        this.$displayLang = document.querySelector('#value_lang');
        this.$formEditLang = document.querySelector('#modal-edit-lang form');
        this.$errorboxEditLang = document.querySelector('#modal-edit-lang .errorbox');
        // Modal
        this.modalEditLang = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-lang');
        // Modaldialog öffnen
        this.$btnEditLang.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditLang.classList.add('hidden');
            // Modal öffnen
            this.modalEditLang.show();
        });
        // Speicherung
        this.$formEditLang.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("lang", this.$inputEditLang.value);
            // Fehler ausblenden
            this.$errorboxEditNexturl.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_lang'), data).then((response)=>{
                // Modal schliessen
                this.modalEditLang.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayLang.textContent = response.lang_name;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditNexturl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditNexturl.classList.remove('hidden');
                // Fokus auf Auswahl
                this.$inputEditLang.focus();
            });
        });
        // --- API Key
        // Button Kopieren
        const $btnsCopy = document.querySelectorAll('button[data-clipboard-text]');
        const codeClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnsCopy);
        codeClipboard.on('success', function(e) {
            // Erfolgsmeldung
            const msg = e.trigger.getAttribute('data-clipboard-success');
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(msg);
        });
        // --- Formular löschen
        // Elemente
        this.$btnDelete = document.querySelector('#modal-delete button.delete');
        // Modal
        this.modalDelete = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-delete');
        // Löschung ausführen
        this.$btnDelete.addEventListener('click', (event)=>{
            const data = new FormData();
            data.append("form_code", this.form_code);
            // Meldungen ausblenden
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'delete'), data).then((response)=>{
                // Weiterleitung zu Formularübersicht
                (0, $bd2663108f285dbc$export$86fbec116b87613f).goto('forms');
            }).catch((error)=>{
                // Modal schliessen
                this.modalDelete.close();
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-settings')) new $ae3ac94ca8b409fc$export$6955bcca4cd3539f();
});







class $d152ce65f8755f78$export$6955bcca4cd3539f {
    constructor(){
        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;
        // --- Option: Spam-Filter
        document.querySelector('#switch_spamfilter').addEventListener('change', (event)=>{
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("use_spamfilter", value);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_usespamfilter'), data).then((response)=>{
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                // Switch zurücksetzen
                switchInstance.undo();
            });
        });
        // --- Option: Captcha
        let $switch_captcha = document.querySelector('#switch_captcha');
        if ($switch_captcha) document.querySelector('#switch_captcha').addEventListener('change', (event)=>{
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("use_captcha", value);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_usecaptcha'), data).then((response)=>{
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                // Switch zurücksetzen
                switchInstance.undo();
            });
        });
        // --- freigegebene Domains
        new (0, $9cc26bef22bc9452$export$9497edad05e15c40)('#referrerdomains', true, this.form_code);
        // --- Honeypot
        // Elemente
        this.$btnEditHoneypot = document.querySelector('button.honeypot');
        this.$inputEditHoneypot = document.querySelector('#modal-edit-honeypot input[name=honeypot]');
        this.$displayHoneypot = document.querySelector('#value_honeypot');
        this.$displayHoneypotEmpty = document.querySelector('#value_honeypot_empty');
        this.$formEditHoneypot = document.querySelector('#modal-edit-honeypot form');
        this.$errorboxEditHoneypot = document.querySelector('#modal-edit-honeypot .errorbox');
        // Modal
        this.modalEditHoneypot = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-honeypot');
        // Modaldialog öffnen
        this.$btnEditHoneypot.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditHoneypot.classList.add('hidden');
            // Modal öffnen
            this.modalEditHoneypot.show();
        });
        // Speicherung
        this.$formEditHoneypot.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("honeypot", this.$inputEditHoneypot.value);
            // Fehler ausblenden
            this.$errorboxEditHoneypot.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_honeypot'), data).then((response)=>{
                // Modal schliessen
                this.modalEditHoneypot.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                if (this.$inputEditHoneypot.value.trim() == '') {
                    this.$displayHoneypot.classList.add('hidden');
                    this.$displayHoneypotEmpty.classList.remove('hidden');
                } else {
                    this.$displayHoneypot.classList.remove('hidden');
                    this.$displayHoneypotEmpty.classList.add('hidden');
                    this.$displayHoneypot.textContent = this.$inputEditHoneypot.value;
                }
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditHoneypot.querySelector('.cont').textContent = error.message;
                this.$errorboxEditHoneypot.classList.remove('hidden');
            });
        });
        // --- Option: Email Validierung
        document.querySelector('#switch_emailvalidation').addEventListener('change', (event)=>{
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("use_emailvalidation", value);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_useemailvalidation'), data).then((response)=>{
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                // Switch zurücksetzen
                switchInstance.undo();
            });
        });
        // --- Option: IP-Blacklist
        document.querySelector('#switch_ipblacklist').addEventListener('change', (event)=>{
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();
            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("use_ipblacklist", value);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'save_useipblacklist'), data).then((response)=>{
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                // Switch zurücksetzen
                switchInstance.undo();
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-spam')) new $d152ce65f8755f78$export$6955bcca4cd3539f();
});









class $d2ddf2bf1b02f675$export$300e34223a1d535f {
    // Initialisieren
    constructor(selector, storing = null, form_code = ''){
        // Hauptelement
        this.$ele = document.querySelector(selector);
        // direkte Speicherung
        this.storing = storing;
        this.form_code = form_code;
        // Vars
        this.id = this.$ele.getAttribute('id');
        this.modalAddSelector = '#' + this.id + ' .modal';
        this.maxCount = parseInt(this.$ele.getAttribute('data-maxcount'));
        this.addressesNotReleased = [];
        // Elemente
        this.$list = this.$ele.querySelector('ul.list');
        this.$listLiEmpty = this.$list.querySelector('li.empty');
        this.$value = this.$ele.querySelector('input[type=hidden]');
        this.$btnAdd = this.$ele.querySelector('.cont button');
        this.$modalInputSelect = this.$ele.querySelector(this.modalAddSelector + ' .input-text-select');
        this.$modalBtnApply = this.$ele.querySelector(this.modalAddSelector + ' button.apply');
        this.$modalError = this.$ele.querySelector(this.modalAddSelector + ' .error');
        this.modal = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)(this.modalAddSelector);
        // Nachricht für nicht freigeschaltene Adressen
        this.msgNotReleased = this.$ele.getAttribute('data-msg-notreleased');
        // Öffnen des Modal
        this.$btnAdd.addEventListener('click', (event)=>{
            // Fehler ausblenden
            this.$modalError.classList.add('hidden');
            // Modal anzeigen
            this.modal.show();
        });
        // Auswahl einer vorhandenen Adresse
        const $select = this.$modalInputSelect.querySelector('select');
        if ($select) $select.addEventListener('change', (event)=>{
            const value = $select.value;
            const $input = $select.parentNode.querySelector('input');
            if ($input) $input.value = value;
        });
        // Neue Adresse übernehmen
        this.$modalBtnApply.addEventListener('click', (event)=>{
            const $input = this.$modalInputSelect.querySelector('input');
            if ($input) this.addAddress($input.value);
        });
        // Nicht bestätigte Adressen laden
        this.addressesNotReleased = [];
        const strNotreleased = this.$ele.getAttribute('data-addresses-notreleased');
        if (strNotreleased) this.addressesNotReleased = strNotreleased.split(",");
        // Liste anzeigen
        this.updateList();
    }
    // Anzeige der Liste aktualisieren
    updateList() {
        // Liste der Adressen
        const addresses = this.getAddresses();
        // vorhandene Einträge entfernen
        const entries = this.$list.querySelectorAll('li.entry');
        entries.forEach((el)=>{
            el.parentNode.removeChild(el);
        });
        // keine Adressen gewählt
        if (addresses.length === 0) this.$listLiEmpty.style.display = 'flex';
        else {
            this.$listLiEmpty.style.display = 'none';
            addresses.forEach((address)=>{
                const element = document.createElement('li');
                element.classList.add('entry');
                const html = `
<div>
    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
    <span>` + address + `</span>
</div>
<div>
    <button type="button" class="info hint--top-left" aria-label="` + this.msgNotReleased + `" tabindex="-1">
        <svg class="text-yellow-400" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" fill-rule="evenodd"></path></svg>
    </button>
    <button type="button" class="remove">
        <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12"></path></svg>
    </button>
</div>`;
                element.innerHTML = html;
                const $btnRemove = element.querySelector('button.remove');
                $btnRemove.addEventListener('click', (event)=>{
                    const $span = element.querySelector('span');
                    const ad = $span.textContent;
                    this.removeAddress(ad);
                });
                if (!this.addressesNotReleased.includes(address)) element.querySelector('button.info').remove();
                this.$list.appendChild(element);
            });
        }
    }
    // liefert Liste der aktuelle gewählten Adressen
    getAddresses() {
        // Liste der Adressen
        const addresses = this.$value.value.split(",");
        addresses.forEach((address, i)=>{
            if (address === "") addresses.splice(i, 1);
        });
        return addresses;
    }
    // Adresse hinzufügen
    addAddress(address) {
        // Fehler ausblenden
        this.$modalError.classList.add('hidden');
        // Adresse nicht möglich
        const valid = this.validateNewAddress(address);
        if (valid !== true) {
            const p = this.$modalError.querySelectorAll('p');
            p.forEach(($el)=>{
                if ($el.classList.contains(valid)) {
                    $el.classList.remove('hidden');
                    this.$modalError.classList.remove('hidden');
                } else $el.classList.add('hidden');
            });
            this.$modalError.classList.remove('hidden');
            return;
        }
        const success_function = ()=>{
            // Eingabe leeren
            const $input = this.$modalInputSelect.querySelector('input');
            $input.value = '';
            // Zur Liste der nichtfreigegebenen Adressen hinzufügen
            // ... wenn nicht in Auswahlliste
            let found = false;
            this.$modalInputSelect.querySelectorAll('select > option').forEach(($option)=>{
                if ($option.getAttribute('value') === address) found = true;
            });
            if (!found) this.addressesNotReleased.push(address);
            // Adresse hinzufügen
            const addresses = this.getAddresses();
            addresses.push(address);
            this.$value.value = addresses.join(',');
            this.updateList();
            this.modal.close();
        };
        // direkte Speicherung
        if (this.storing) {
            let url = '';
            const data = new FormData();
            if (this.storing === 'form') url = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form-delivery') + "/" + this.form_code + "/mailing/add_mail";
            else if (this.storing === 'account') url = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('profile', 'add_mail');
            data.append("address", address);
            // Meldungen ausblenden
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(url, data).then((response)=>{
                // Erfolgreich
                success_function();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
            });
        } else success_function();
    }
    // Adresse aus Liste entfernen
    removeAddress(address) {
        const success_function = ()=>{
            const addresses = this.getAddresses();
            let newList = [];
            addresses.forEach((a, i)=>{
                if (a !== address) newList.push(a);
            });
            this.$value.value = newList.join(',');
            this.updateList();
        };
        // direkte Speicherung
        if (this.storing) {
            let url = '';
            const data = new FormData();
            if (this.storing === 'form') url = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form-delivery') + "/" + this.form_code + "/mailing/remove_mail";
            else if (this.storing === 'account') url = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('profile', 'remove_mail');
            data.append("address", address);
            // Meldungen ausblenden
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().hideAll();
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(url, data).then((response)=>{
                // Erfolgreich
                success_function();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
            });
        } else success_function();
    }
    // Prüft ob neue Adresse möglich ist
    validateNewAddress(address) {
        // keine Adresse angegeben
        if (address === "" || typeof address !== 'string') return 'format';
        // Format prüfen
        const re = /^\S+@\S+\.\S+$/;
        if (!re.test(address)) return 'format';
        // bereits in der Liste
        const addresses = this.getAddresses();
        if (addresses.includes(address)) return 'existing';
        // maximale Anzahl erreicht
        if (addresses.length >= this.maxCount) return 'count';
        // passt
        return true;
    }
    // Modal schliessen
    closeModal() {
        this.modal.close();
    }
}




class $6503dfbf6c01ec4c$export$6955bcca4cd3539f {
    constructor(){
        // --- Passwort
        // Elemente
        this.$btnEditPassword = document.querySelector('button.password');
        this.$inputPasswordCurrent = document.querySelector('#modal-edit-password input[name=password_current]');
        this.$inputPasswordNew = document.querySelector('#modal-edit-password input[name=password_new]');
        this.$formEditPassword = document.querySelector('#modal-edit-password form');
        this.$errorboxEditPassword = document.querySelector('#modal-edit-password .errorbox');
        // Modal
        this.modalEditPassword = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-password');
        // Modaldialog öffnen
        this.$btnEditPassword.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditPassword.classList.add('hidden');
            // Modal öffnen
            this.modalEditPassword.show();
        });
        // Speicherung
        this.$formEditPassword.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("password_current", this.$inputPasswordCurrent.value);
            data.append("password_new", this.$inputPasswordNew.value);
            // Fehler ausblenden
            this.$errorboxEditPassword.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('profile', 'save_password'), data).then((response)=>{
                // Modal schliessen
                this.modalEditPassword.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditPassword.querySelector('.cont').textContent = error.message;
                this.$errorboxEditPassword.classList.remove('hidden');
            });
        });
        // --- Empfängeradressen
        const mailaddresses = new (0, $d2ddf2bf1b02f675$export$300e34223a1d535f)('#mailaddresses', 'account');
        // --- Zeitzone
        // Elemente
        this.$btnEditTimezone = document.querySelector('button.timezone');
        this.$inputEditTimezone = document.querySelector('#modal-edit-timezone select');
        this.$displayTimezone = document.querySelector('#value_timezone');
        this.$formEditTimezone = document.querySelector('#modal-edit-timezone form');
        this.$errorboxEditTimezone = document.querySelector('#modal-edit-timezone .errorbox');
        // Modal
        this.modalEditTimezone = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-timezone');
        // Modaldialog öffnen
        this.$btnEditTimezone.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditTimezone.classList.add('hidden');
            // Auswahl übernehmen
            this.$inputEditTimezone.value = this.$displayTimezone.textContent;
            // Modal öffnen
            this.modalEditTimezone.show();
        });
        // Speicherung
        this.$formEditTimezone.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("timezone", this.$inputEditTimezone.value);
            // Fehler ausblenden
            this.$errorboxEditTimezone.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('profile', 'save_timezone'), data).then((response)=>{
                // Modal schliessen
                this.modalEditTimezone.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayTimezone.textContent = this.$inputEditTimezone.value;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditTimezone.querySelector('.cont').textContent = error.message;
                this.$errorboxEditTimezone.classList.remove('hidden');
            });
        });
        // --- Option: Newsletter
        document.querySelector('#switch_newsletter').addEventListener('change', (event)=>{
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();
            const data = new FormData();
            data.append("use_newsletter", value);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('profile', 'save_usenewsletter'), data).then((response)=>{
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
                // Switch zurücksetzen
                switchInstance.undo();
            });
        });
        // --- Account löschen
        this.$btnDeleteAccount = document.querySelector('button.delete-account');
        if (this.$btnDeleteAccount) {
            // Elemente
            this.$inputPasswordDeleteAccount = document.querySelector('#modal-delete-account input[name=password]');
            this.$formDeleteAccount = document.querySelector('#modal-delete-account form');
            this.$errorboxDeleteAccount = document.querySelector('#modal-delete-account .errorbox');
            // Modal
            this.modalDeleteAccount = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-delete-account');
            // Modaldialog öffnen
            this.$btnDeleteAccount.addEventListener('click', (event)=>{
                // Fehlermeldung ausblenden
                this.$errorboxDeleteAccount.classList.add('hidden');
                // Modal öffnen
                this.modalDeleteAccount.show();
            });
            // Löschung ausführen
            this.$formDeleteAccount.addEventListener('submit', (event)=>{
                event.preventDefault();
                const data = new FormData();
                data.append("password", this.$inputPasswordDeleteAccount.value);
                // Fehler ausblenden
                this.$errorboxDeleteAccount.classList.add('hidden');
                // Senden
                new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('profile', 'delete_account'), data).then((response)=>{
                    // Modal schliessen
                    this.modalDeleteAccount.close();
                    // Weiterleitung zur Startseite
                    (0, $bd2663108f285dbc$export$86fbec116b87613f).gotoUrl("https://form.taxi");
                }).catch((error)=>{
                    // Fehlermeldung anzeigen
                    this.$errorboxDeleteAccount.querySelector('.cont').textContent = error.message;
                    this.$errorboxDeleteAccount.classList.remove('hidden');
                });
            });
        }
        // --- Upgrade
        document.getElementById('wrapper').addEventListener('click', (event)=>{
            if (event.target) {
                // Email Adressen
                const $btnUpgrade = event.target.closest('a.upgrade_mailaddresses');
                if ($btnUpgrade) {
                    event.preventDefault();
                    // Modal zur neuen Empfängeradresse schliessen
                    mailaddresses.closeModal();
                    // Upgrade
                    const successMsg = $btnUpgrade.dataset.successmsg ?? '';
                    (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                        // Erfolgsmeldung
                        new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success("Upgrade", successMsg);
                    }, "mailaddresses");
                }
            }
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('profile')) new $6503dfbf6c01ec4c$export$6955bcca4cd3539f();
});






class $0eaac9c548882bf7$export$6955bcca4cd3539f {
    constructor(){
        // Paddle initialisieren
        Paddle.Setup({
            vendor: 120516
        });
        // Paket bestellen
        const $btnOrder = document.querySelector('button.order');
        const $inputBilling = document.querySelector('input[name=billing_yearly]');
        if ($btnOrder) {
            // Switch
            const $showPriceAnnual = document.querySelector(".show-price-annual");
            const $showPriceMonthly = document.querySelector(".show-price-monthly");
            document.querySelector('#switch_upgrade_billing').addEventListener('change', (event)=>{
                if (event.detail.switch.isActivated()) {
                    $showPriceAnnual.classList.remove("hidden");
                    $showPriceMonthly.classList.add("hidden");
                } else {
                    $showPriceAnnual.classList.add("hidden");
                    $showPriceMonthly.classList.remove("hidden");
                }
            });
            // Bestellung
            $btnOrder.addEventListener('click', (event)=>{
                const switchInstance = new (0, $fbae5fa1d8d96e27$export$b5d5cf8927ab7262)("#switch_upgrade_billing");
                const isYearly = switchInstance.isActivated();
                let productId = 0;
                if (isYearly) productId = parseInt(event.currentTarget.getAttribute('data-productid-yearly'));
                else productId = parseInt(event.currentTarget.getAttribute('data-productid-monthly'));
                const account_email = event.currentTarget.getAttribute('data-account-email');
                const account_id = parseInt(event.currentTarget.getAttribute('data-account-id'));
                const locale = event.currentTarget.getAttribute('data-locale');
                const title = event.currentTarget.getAttribute('data-title');
                const plan = event.currentTarget.getAttribute('data-plan');
                const referrer = event.currentTarget.getAttribute('data-referrer');
                const passthrough = {};
                if (account_id) passthrough.account_id = account_id;
                if (referrer) passthrough.referrer = referrer;
                Paddle.Checkout.open({
                    product: productId,
                    email: account_email,
                    passthrough: JSON.stringify(passthrough),
                    successCallback: (data)=>{
                        // Weiterleitung zu Seite Order-Processing
                        (0, $bd2663108f285dbc$export$86fbec116b87613f).gotoUrl((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('membership', 'order_processing', '', {
                            paddle_user_id: data.user.id,
                            to_plan: plan,
                            lang: locale
                        }));
                    },
                    allowQuantity: false,
                    locale: locale,
                    title: title
                });
            });
        }
        // Abo updaten
        const $btnUpdate = document.querySelector('button.update');
        if ($btnUpdate) $btnUpdate.addEventListener('click', (event)=>{
            const update_url = event.currentTarget.getAttribute('data-update-url');
            const success_url = event.currentTarget.getAttribute('data-success-url');
            const locale = event.currentTarget.getAttribute('data-locale');
            Paddle.Checkout.open({
                override: update_url,
                success: success_url,
                locale: locale
            });
        });
        // Abo kündigen
        const $btnCancel = document.querySelector('button.cancel');
        if ($btnCancel) $btnCancel.addEventListener('click', (event)=>{
            const cancel_url = event.currentTarget.getAttribute('data-cancel-url');
            const success_url = event.currentTarget.getAttribute('data-success-url');
            const locale = event.currentTarget.getAttribute('data-locale');
            Paddle.Checkout.open({
                override: cancel_url,
                success: success_url,
                locale: locale
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('membership')) new $0eaac9c548882bf7$export$6955bcca4cd3539f();
});






class $860f9c8b9c508f14$export$be3aa080178503e1 {
    constructor(selectorOrElement){
        this.el = selectorOrElement instanceof Element ? selectorOrElement : document.querySelector(selectorOrElement);
        if (!this.el) {
            console.warn(`Gauge: No element found for "${selectorOrElement}"`);
            return;
        }
        this.START_ANGLE = 250;
        this.TOTAL_ANGLE = 220;
        this.svgEl = this.el.querySelector('svg');
        this.perc = this.el.querySelector('text.percentage');
        this.arc = null;
        this._drawTrack();
        this.init();
    }
    polarToCartesian(cx, cy, radius, angle) {
        const radians = (angle - 90) * Math.PI / 180.0;
        return [
            Math.round((cx + radius * Math.cos(radians)) * 100) / 100,
            Math.round((cy + radius * Math.sin(radians)) * 100) / 100
        ];
    }
    svgCircleArcPath(x, y, radius, startAngle, endAngle) {
        const startXY = this.polarToCartesian(x, y, radius, startAngle);
        const endXY = this.polarToCartesian(x, y, radius, endAngle);
        const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;
        return `M ${startXY[0]} ${startXY[1]} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endXY[0]} ${endXY[1]}`;
    }
    _drawTrack() {
        const track = this.svgEl.querySelector('.track-arc');
        if (!track) return;
        const path = this.svgCircleArcPath(500, 500, 450, this.START_ANGLE, this.START_ANGLE + this.TOTAL_ANGLE);
        track.setAttribute('d', path);
    }
    // Gibt die interpolierte Farbe für einen gegebenen Prozentwert zurück
    _colorForValue(pct) {
        if (pct >= 90) return '#EF4444';
        if (pct >= 70) return '#eab308';
        return '#2563EB';
    }
    animateArc(ratio) {
        if (this.arc) this.arc.remove();
        this.arc = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.arc.classList.add('data-arc');
        this.svgEl.insertBefore(this.arc, this.perc);
        const duration = Math.round(1500 * ratio);
        const startTime = performance.now();
        const tick = (now)=>{
            const elapsed = Math.min(now - startTime, duration);
            const t = duration > 0 ? elapsed / duration : 1;
            const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            const val = ease * ratio;
            const pct = val * 100;
            const endAngle = this.START_ANGLE + val * this.TOTAL_ANGLE;
            this.arc.setAttribute('d', this.svgCircleArcPath(500, 500, 450, this.START_ANGLE, endAngle));
            const color = this._colorForValue(pct);
            this.arc.style.stroke = color;
            this.perc.style.fill = color;
            this.perc.textContent = `${Math.round(pct)}%`;
            if (elapsed < duration) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    }
    init() {
        const ratio = parseFloat(this.el.dataset.ratio);
        this.animateArc(ratio);
    }
}


class $4ceeeb3a27312401$export$6955bcca4cd3539f {
    constructor(){
        // Alle Gauges initialisieren
        const gauges = document.querySelectorAll(".gauge");
        if (gauges.length > 0) gauges.forEach(($gauge)=>{
            new (0, $860f9c8b9c508f14$export$be3aa080178503e1)($gauge);
        });
        // Progressbars animieren
        const progressbars = document.querySelectorAll("main .progressbar");
        progressbars.forEach(($progressbar)=>{
            if ($progressbar.hasAttribute("data-percent")) {
                const percent = parseInt($progressbar.dataset.percent);
                const $bar = $progressbar.firstElementChild.firstElementChild;
                let color = '#2563EB';
                if (percent >= 70) color = '#eab308';
                if (percent >= 90) color = '#EF4444';
                // erst auf 0 setzen
                $bar.classList.add("notrans");
                $bar.style.width = "0%";
                $bar.style.backgroundColor = color;
                setTimeout(()=>{
                    // Zielwert
                    $bar.classList.remove("notrans");
                    $bar.style.width = percent + "%";
                }, 10);
            }
        });
        // Upgrade-Links
        const upgradeLinks = document.querySelectorAll("main a.upgrade");
        if (upgradeLinks.length > 0) upgradeLinks.forEach(($link)=>{
            $link.addEventListener("click", (event)=>{
                event.preventDefault();
                // Upgrade
                const successMsg = $link.dataset.successmsg ?? '';
                const upgradetype = $link.dataset.upgradetype ?? '';
                (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                    // Erfolgsmeldung
                    new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success("Upgrade", successMsg);
                    // Nach 2 Sek. Seite neu laden
                    setTimeout(()=>{
                        location.reload();
                    }, 2000);
                }, upgradetype);
            });
        });
        // Chart der Sendungen
        const $chart_submissions = document.querySelector("#chart-submissions");
        if ($chart_submissions) {
            let months_list = $chart_submissions.dataset?.monthsList;
            if (months_list) months_list = months_list.split(',');
            let months_subcounts = $chart_submissions.dataset?.monthsSubcounts;
            if (months_subcounts) months_subcounts = months_subcounts.split(',').map((num)=>parseInt(num));
            const locale_submissions = $chart_submissions.dataset?.localeSubmissions;
            const locales = [
                {
                    "name": "en",
                    "options": {
                        "months": [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        "shortMonths": [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        "days": [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        "shortDays": [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        "toolbar": {
                            "exportToSVG": "Download SVG",
                            "exportToPNG": "Download PNG",
                            "menu": "Menu",
                            "selection": "Selection",
                            "selectionZoom": "Selection Zoom",
                            "zoomIn": "Zoom In",
                            "zoomOut": "Zoom Out",
                            "pan": "Panning",
                            "reset": "Reset Zoom"
                        }
                    }
                },
                {
                    "name": "de",
                    "options": {
                        "months": [
                            "Januar",
                            "Februar",
                            "M\xe4rz",
                            "April",
                            "Mai",
                            "Juni",
                            "Juli",
                            "August",
                            "September",
                            "Oktober",
                            "November",
                            "Dezember"
                        ],
                        "shortMonths": [
                            "Jan",
                            "Feb",
                            "M\xe4r",
                            "Apr",
                            "Mai",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Okt",
                            "Nov",
                            "Dez"
                        ],
                        "days": [
                            "Sonntag",
                            "Montag",
                            "Dienstag",
                            "Mittwoch",
                            "Donnerstag",
                            "Freitag",
                            "Samstag"
                        ],
                        "shortDays": [
                            "So",
                            "Mo",
                            "Di",
                            "Mi",
                            "Do",
                            "Fr",
                            "Sa"
                        ],
                        "toolbar": {
                            "exportToSVG": "SVG herunterladen",
                            "exportToPNG": "PNG herunterladen",
                            "menu": "Men\xfc",
                            "selection": "Auswahl",
                            "selectionZoom": "Auswahl-Zoom",
                            "zoomIn": "Vergr\xf6\xdfern",
                            "zoomOut": "Verkleinern",
                            "pan": "Verschieben",
                            "reset": "Zoom zur\xfccksetzen"
                        }
                    }
                }
            ];
            if (months_list && months_subcounts) {
                const options = {
                    chart: {
                        type: 'line',
                        animations: {
                            enabled: true,
                            speed: 800
                        },
                        toolbar: {
                            show: false
                        },
                        foreColor: '#6B7280',
                        height: 230,
                        zoom: {
                            enabled: false
                        },
                        locales: locales,
                        defaultLocale: (0, $bd2663108f285dbc$export$86fbec116b87613f).getLang()
                    },
                    series: [
                        {
                            name: locale_submissions,
                            data: months_subcounts
                        }
                    ],
                    xaxis: {
                        categories: months_list,
                        type: 'category',
                        tooltip: {
                            enabled: false
                        }
                    },
                    legend: {
                        show: false
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3
                    },
                    colors: [
                        '#EC4899'
                    ],
                    dataLabels: {
                        enabled: false
                    },
                    tooltip: {
                        enabled: true,
                        enabledOnSeries: [
                            0
                        ],
                        x: {
                            show: false
                        },
                        y: {
                            formatter: undefined,
                            title: {
                                formatter: (seriesName)=>locale_submissions
                            }
                        },
                        marker: {
                            show: false
                        }
                    }
                };
                const chart = new ApexCharts($chart_submissions, options);
                chart.render();
            }
        }
        // CountUps
        let separator = ",";
        let decimal = ".";
        if ((0, $bd2663108f285dbc$export$86fbec116b87613f).getLang() == "de") {
            separator = ".";
            decimal = ",";
        }
        const countUpElements = document.querySelectorAll('span.count-up');
        countUpElements.forEach(($el)=>{
            const targetValue = parseInt($el.getAttribute('data-value'));
            let countUp = new (0, $bacf01ab4aec807d$export$1567cc001e3d0c1d)($el, targetValue, {
                duration: 0.8,
                separator: separator,
                decimal: decimal,
                startVal: 0
            });
            countUp.start();
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('usage')) new $4ceeeb3a27312401$export$6955bcca4cd3539f();
});








class $cfe66e21d5b2bee6$export$6955bcca4cd3539f {
    constructor(){
        // Template für App-Zugänge
        this.tplAppAccesses = $4b6fe9457f608df7$exports.compile(document.getElementById('tpl_app_accesses').innerHTML.replace(/=&gt;/g, '=>'));
        // Elemente
        this.$contentAccesses = document.querySelector('#content_app_accesses');
        // Zugänge laden
        this.loadAppAccesses();
        // --- Neuer App-Zugang
        // Modal: Zugang anlegen
        this.$modalAddAccess = document.querySelector('#modal-add-access');
        this.modalAddAccess = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-add-access');
        this.$formAddAccess = this.$modalAddAccess.querySelector('form');
        this.$errorboxAddAccess = this.$modalAddAccess.querySelector('.errorbox');
        // Formular-Option in Modal
        this.$formRadiosAddAccess = this.$modalAddAccess.querySelectorAll('input[name=form_access_type]');
        this.$formRadiosAddAccess.forEach(($radio)=>{
            $radio.addEventListener('change', (event)=>{
                this.refreshFormMarkup(this.$formAddAccess);
            });
        });
        // Speicherung
        this.$formAddAccess.addEventListener('submit', (event)=>{
            event.preventDefault();
            // Sendedaten
            const data = new FormData();
            var typeValue = this.$formAddAccess.querySelector('input[name="form_access_type"]:checked').value;
            var access_forms_str = "";
            if (typeValue === "selection") {
                var checkbxs = this.$modalAddAccess.querySelectorAll('input[name=form_selected]:checked');
                checkbxs.forEach(($bx)=>{
                    access_forms_str += $bx.value + ",";
                });
                if (access_forms_str.length > 0) access_forms_str = access_forms_str.substring(0, access_forms_str.length - 1);
            } else if (typeValue === "all") access_forms_str = "all";
            data.append("access_forms", access_forms_str);
            // Fehler ausblenden
            this.$errorboxAddAccess.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('app', 'add_access'), data).then((response)=>{
                // Modal schliessen
                this.modalAddAccess.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxAddAccess.querySelector('.cont').textContent = error.message;
                this.$errorboxAddAccess.classList.remove('hidden');
            });
        });
        // --- Formularfreigaben bearbeiten
        // Modal
        this.$modalEditForms = document.querySelector('#modal-edit-forms');
        this.modalEditForms = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-forms');
        this.$formEditForms = this.$modalEditForms.querySelector('form');
        this.$errorboxEditForms = this.$modalEditForms.querySelector('.errorbox');
        // Formular-Option in Modal
        this.$formRadiosEditForms = this.$modalEditForms.querySelectorAll('input[name=form_access_type]');
        this.$formRadiosEditForms.forEach(($radio)=>{
            $radio.addEventListener('change', (event)=>{
                this.refreshFormMarkup(this.$formEditForms);
            });
        });
        // Speicherung
        this.$formEditForms.addEventListener('submit', (event)=>{
            event.preventDefault();
            // Sendedaten
            const data = new FormData();
            data.append("access_id", this.$formEditForms.querySelector('input[name="access_id"]').value);
            var typeValue = this.$formEditForms.querySelector('input[name="form_access_type"]:checked').value;
            var access_forms_str = "";
            if (typeValue === "selection") {
                var checkbxs = this.$modalEditForms.querySelectorAll('input[name=form_selected]:checked');
                checkbxs.forEach(($bx)=>{
                    access_forms_str += $bx.value + ",";
                });
                if (access_forms_str.length > 0) access_forms_str = access_forms_str.substring(0, access_forms_str.length - 1);
            } else if (typeValue === "all") access_forms_str = "all";
            data.append("access_forms", access_forms_str);
            // Fehler ausblenden
            this.$errorboxEditForms.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('app', 'save_access_forms'), data).then((response)=>{
                // Modal schliessen
                this.modalEditForms.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditForms.querySelector('.cont').textContent = error.message;
                this.$errorboxEditForms.classList.remove('hidden');
            });
        });
        // --- Zugang löschen
        // Modal
        this.$modalDeleteAccess = document.querySelector('#modal-delete-access');
        this.modalDeleteAccess = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-delete-access');
        // Löschung ausführen
        const $btnModalDeleteAccess = this.$modalDeleteAccess.querySelector('button.delete');
        $btnModalDeleteAccess.addEventListener('click', (event)=>{
            // Sendedaten
            const data = new FormData();
            data.append("access_id", this.$modalDeleteAccess.dataset.id);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('app', 'delete_access'), data).then((response)=>{
                // Modal schliessen
                this.modalDeleteAccess.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            }).catch((error)=>{
                // Modal schliessen
                this.modalDeleteAccess.close();
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
            });
        });
        // --- Verbindung löschen
        // Modal
        this.$modalDeleteConnection = document.querySelector('#modal-delete-connection');
        this.modalDeleteConnection = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-delete-connection');
        // Löschung ausführen
        const $btnModalDeleteConnection = this.$modalDeleteConnection.querySelector('button.delete');
        $btnModalDeleteConnection.addEventListener('click', (event)=>{
            // Sendedaten
            const data = new FormData();
            data.append("connection_id", this.$modalDeleteConnection.dataset.id);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('app', 'delete_connection'), data).then((response)=>{
                // Modal schliessen
                this.modalDeleteConnection.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            }).catch((error)=>{
                // Modal schliessen
                this.modalDeleteConnection.close();
                // Fehlermeldung anzeigen
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
            });
        });
    }
    // App-Zugänge laden
    loadAppAccesses() {
        // Daten abrufen
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('app', 'load_accesses_data')).then((response)=>{
            // Inhalt aus Template erstellen
            this.$contentAccesses.innerHTML = this.tplAppAccesses(response, $4b6fe9457f608df7$exports.defaultConfig);
            // Events ---
            // PopUps initialisieren
            const popups = this.$contentAccesses.querySelectorAll(".popup");
            popups.forEach(($ele)=>{
                const p = new (0, $d19f7743c2a8a520$export$129a32eedafa97c5)($ele, (instance)=>{
                    window.Popups.forEach((p)=>{
                        if (p !== instance) p.close();
                    });
                });
                window.Popups.push(p);
            });
            // Klick auf Anlegen-Buttons
            const $btnsAddAccess = this.$contentAccesses.querySelectorAll('button.add-access');
            $btnsAddAccess.forEach(($btn)=>{
                $btn.addEventListener('click', (event)=>{
                    // Fehlermeldung ausblenden
                    this.$errorboxAddAccess.classList.add('hidden');
                    // Modal öffnen
                    this.modalAddAccess.show();
                });
            });
            // Aktion: Formularfreigaben
            const $btnsActionForms = this.$contentAccesses.querySelectorAll('button.action.forms');
            $btnsActionForms.forEach(($btn)=>{
                $btn.addEventListener('click', (event)=>{
                    const $accessLi = event.currentTarget.closest('li');
                    const accessId = $accessLi.dataset.id;
                    this.openEditAccessForms(accessId);
                });
            });
            // Aktion: Zugang löschen
            const $btnsActionDeleteAccess = this.$contentAccesses.querySelectorAll('button.action.delete');
            $btnsActionDeleteAccess.forEach(($btn)=>{
                $btn.addEventListener('click', (event)=>{
                    // Access-ID in Modal übernehmen
                    const $accessLi = event.currentTarget.closest('li');
                    this.$modalDeleteAccess.dataset.id = $accessLi.dataset.id;
                    // Modal öffnen
                    this.modalDeleteAccess.show();
                });
            });
            // Aktion: Verbindung löschen
            const $btnsActionDeleteConnection = this.$contentAccesses.querySelectorAll('.devicelist button.remove');
            $btnsActionDeleteConnection.forEach(($btn)=>{
                $btn.addEventListener('click', (event)=>{
                    // Connection-ID in Modal übernehmen
                    const $connectionLi = event.currentTarget.closest('li');
                    this.$modalDeleteConnection.dataset.id = $connectionLi.dataset.id;
                    // Modal öffnen
                    this.modalDeleteConnection.show();
                });
            });
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
        }).finally(()=>{});
    }
    // Modal mit Formularfreigaben öffnen
    openEditAccessForms(access_id) {
        // Forms-Value
        const $li = this.$contentAccesses.querySelector('ul.accesses > li[data-id="' + access_id + '"]');
        const forms = $li.dataset.forms;
        // Formular vorbelegen
        const $inputAccessId = this.$modalEditForms.querySelector('input[name=access_id]');
        $inputAccessId.value = access_id;
        const $radioAll = this.$modalEditForms.querySelector('input[name=form_access_type][value="all"]');
        const $radioSelection = this.$modalEditForms.querySelector('input[name=form_access_type][value="selection"]');
        if (forms == "all") {
            $radioAll.checked = true;
            $radioSelection.checked = false;
        } else {
            $radioAll.checked = false;
            $radioSelection.checked = true;
            const parts = forms.split(',');
            const $selForms = this.$modalEditForms.querySelectorAll('input[name="form_selected"]');
            $selForms.forEach(($radio)=>{
                $radio.checked = parts.includes($radio.value);
            });
        }
        this.refreshFormMarkup(this.$formEditForms);
        // Fehler ausblenden
        const $errorboxEditForms = this.$modalEditForms.querySelector('.errorbox');
        $errorboxEditForms.classList.add('hidden');
        // Modal öffnen
        this.modalEditForms.show();
    }
    // HTML-Markup in Formular entsprechend Formularfreigabe aktualisieren
    refreshFormMarkup($form) {
        var val = $form.querySelector('input[name=form_access_type]:checked').value;
        const $formSelection = $form.querySelector('.form-selection');
        const $formCheckboxes = $form.querySelectorAll('.form-selection input[type=checkbox]');
        const $formtypeAll = $form.querySelector('.form-type.all');
        const $formtypeSelection = $form.querySelector('.form-type.selection');
        if (val === "selection") {
            $formSelection.classList.remove("disabled");
            $formCheckboxes.forEach(($checkbox)=>{
                $checkbox.removeAttribute("disabled");
            });
            $formtypeAll.classList.remove("active");
            $formtypeSelection.classList.add("active");
        } else {
            $formSelection.classList.add("disabled");
            $formCheckboxes.forEach(($checkbox)=>{
                $checkbox.setAttribute("disabled", "disabled");
                $checkbox.checked = false;
            });
            $formtypeAll.classList.add("active");
            $formtypeSelection.classList.remove("active");
        }
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('app')) new $cfe66e21d5b2bee6$export$6955bcca4cd3539f();
});









class $ba62b04c1feb993b$export$6955bcca4cd3539f {
    constructor(){
        // Text Datenschutzerklärung ---------------------
        // HTML-Code kopieren
        const $btnCopyHtml = document.querySelector('.copy-html');
        const htmlClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnCopyHtml, {
            text: function(trigger) {
                const $privacy_text = document.querySelector(".privacy-terms-text");
                let code = $privacy_text.innerHTML.trim();
                return code;
            }
        });
        htmlClipboard.on('success', (event)=>{
            event.clearSelection();
            const msg = event.trigger.dataset.successmsg ?? "Copied!";
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(msg);
        });
        // Text kopieren
        const $btnCopyText = document.querySelector('.copy-text');
        const textClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnCopyText, {
            text: function(trigger) {
                const $privacy_text = document.querySelector(".privacy-terms-text");
                let text = $privacy_text.textContent.trim();
                return text;
            }
        });
        textClipboard.on('success', (event)=>{
            event.clearSelection();
            const msg = event.trigger.dataset.successmsg ?? "Copied!";
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(msg);
        });
        // AV-Vertrag ---------------------
        // Template für AV-Anzeige
        this.tplAv = $4b6fe9457f608df7$exports.compile(document.getElementById('tpl_av').innerHTML.replace(/=&gt;/g, '=>'));
        // Elemente
        this.areaLoading = document.querySelector('#area-loading');
        this.areaDisplayAv = document.querySelector('#area-display-av');
        this.areaCreateAv = document.querySelector('#area-create-av');
        this.btnsCreateAv = document.querySelectorAll('button.create-av');
        this.$errorboxCreateAv = document.querySelector('#modal-create-av .errorbox');
        this.$textareaAuftraggeber = document.querySelector('#modal-create-av #auftraggeber');
        this.$textareaAnsprechpartner = document.querySelector('#modal-create-av #ansprechpartner');
        this.$formCreateAv = document.querySelector('#modal-create-av form');
        // Vertrag laden
        this.loadAvContract();
        // Modal
        this.modalCreateAv = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-create-av');
        // Modaldialog öffnen
        this.btnsCreateAv.forEach(($btn)=>{
            $btn.addEventListener('click', (event)=>{
                // Fehlermeldung ausblenden
                this.$errorboxCreateAv.classList.add('hidden');
                // Modal öffnen
                this.modalCreateAv.show();
            });
        });
        // Zeilenanzahl der Textareas begrenzen
        this.$textareaAuftraggeber.addEventListener('input', (event)=>{
            const textarea = event.target;
            const maxRows = parseInt(textarea.getAttribute("rows"), 10);
            if (!maxRows || isNaN(maxRows)) return;
            const lines = textarea.value.split("\n");
            if (lines.length > maxRows) textarea.value = lines.slice(0, maxRows).join("\n");
        });
        this.$textareaAnsprechpartner.addEventListener('input', (event)=>{
            const textarea = event.target;
            const maxRows = parseInt(textarea.getAttribute("rows"), 10);
            if (!maxRows || isNaN(maxRows)) return;
            const lines = textarea.value.split("\n");
            if (lines.length > maxRows) textarea.value = lines.slice(0, maxRows).join("\n");
        });
        // Vertrag erstellen
        this.$formCreateAv.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("auftraggeber", this.$textareaAuftraggeber.value);
            data.append("ansprechpartner", this.$textareaAnsprechpartner.value);
            // Fehler ausblenden
            this.$errorboxCreateAv.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('privacy', 'create_av'), data).then((response)=>{
                // Modal schliessen
                this.modalCreateAv.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // Anzeige aktualisieren
                this.loadAvContract();
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxCreateAv.querySelector('.cont').textContent = error.message;
                this.$errorboxCreateAv.classList.remove('hidden');
            });
        });
    }
    // Av-Vertrag laden
    loadAvContract() {
        // Ladespinner anzeigen
        this.areaDisplayAv.classList.add("hidden");
        this.areaCreateAv.classList.add("hidden");
        this.areaLoading.classList.remove("hidden");
        // Daten abrufen
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('privacy', 'load_av')).then((response)=>{
            // kein Vertrag vorhanden
            if (response.av_available == false) {
                this.areaDisplayAv.classList.add("hidden");
                this.areaCreateAv.classList.remove("hidden");
            } else {
                // Inhalt aus Template erstellen
                this.areaDisplayAv.querySelector(".template-area").innerHTML = this.tplAv(response, $4b6fe9457f608df7$exports.defaultConfig);
                this.areaDisplayAv.classList.remove("hidden");
            }
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
        }).finally(()=>{
            // Ladespinner ausblenden
            this.areaLoading.classList.add("hidden");
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('privacy')) new $ba62b04c1feb993b$export$6955bcca4cd3539f();
});








class $662b46652c6834b5$export$6955bcca4cd3539f {
    constructor(){
        // Intervall für Prozessoren-Reload
        this.intervalReload = null;
        // Templates
        this.tplProcessorsActive = $4b6fe9457f608df7$exports.compile(document.getElementById('tpl_processors_active').innerHTML.replace(/=&gt;/g, '=>'));
        this.tplProcessorsAdd = $4b6fe9457f608df7$exports.compile(document.getElementById('tpl_processors_add').innerHTML.replace(/=&gt;/g, '=>'));
        // Elemente
        this.$contentProcessorsActive = document.querySelector('#content_processors_active');
        this.$contentProcessorsAdd = document.querySelector('#content_processors_add');
        // Daten
        this.form_code = this.$contentProcessorsActive.dataset.formCode;
        // Klick-Events bei Prozessoren
        document.addEventListener('click', (event)=>{
            // Aktivieren
            if (event.target && event.target.matches('*[data-processor-activate]')) {
                event.preventDefault();
                // Pro-Feature
                const isPro = event.target.classList.contains("pro") ? true : false;
                const proStatus = this.$contentProcessorsActive.dataset.isPro === "true" ? true : false;
                if (isPro == true && proStatus != true) {
                    // Upgrade
                    const successMsg = event.target.dataset.upgradeSuccessmsg ?? '';
                    const processor = event.target.dataset.processorActivate ?? '';
                    let upgradeType = "";
                    if (processor == "Autoresponse") upgradeType = 'autoresponse';
                    else if (processor == "Whatsapp") upgradeType = 'whatsapp';
                    (0, $8c22183067da1665$export$2e2bcd8739ae039).open(()=>{
                        // Pro-Status vermerkten
                        this.$contentProcessorsActive.dataset.ispro = "true";
                        // Erfolgsmeldung
                        new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success("Upgrade", successMsg);
                    }, upgradeType);
                } else {
                    this.activateProcessor(event.target.dataset.processorActivate);
                    this.$contentProcessorsActive.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            } else if (event.target && event.target.matches('*[data-processor-deactivate]')) {
                event.preventDefault();
                this.deactivateProcessor(event.target.dataset.processorDeactivate);
            }
        });
        // Prozessoren laden
        this.loadProcessors();
    }
    // Prozessoren laden
    loadProcessors() {
        // Interval zurücksetzen
        if (this.intervalReload) clearInterval(this.intervalReload);
        // Daten abrufen
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().get((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'delivery_processors_load', this.form_code)).then((response)=>{
            // Inhalt aus Template erstellen
            this.$contentProcessorsActive.innerHTML = this.tplProcessorsActive(response, $4b6fe9457f608df7$exports.defaultConfig);
            this.$contentProcessorsAdd.innerHTML = this.tplProcessorsAdd(response, $4b6fe9457f608df7$exports.defaultConfig);
            // PopUps initialisieren
            const popups_active = this.$contentProcessorsActive.querySelectorAll(".popup");
            const popups_add = this.$contentProcessorsAdd.querySelectorAll(".popup");
            const popups = [
                ...popups_active,
                ...popups_add
            ];
            popups.forEach(($ele)=>{
                const p = new (0, $d19f7743c2a8a520$export$129a32eedafa97c5)($ele, (instance)=>{
                    window.Popups.forEach((p)=>{
                        if (p !== instance) p.close();
                    });
                });
                window.Popups.push(p);
            });
        }).catch((error)=>{}).finally(()=>{
        // Prozessoren alle 20 Sek. neu laden
        //this.intervalReload = setInterval(() => { this.loadProcessors() }, 20000);
        });
    }
    // Prozessor aktivieren
    activateProcessor(code) {
        // Sendedaten
        const data = new FormData();
        data.append("form_code", this.form_code);
        data.append("processor", code);
        // Senden
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'activate_delivery_processor'), data).then((response)=>{
            // Erfolgsmeldung
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            // Anzeige neu laden
            this.loadProcessors();
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
        });
    }
    // Prozessor deaktivieren
    deactivateProcessor(code) {
        // Sendedaten
        const data = new FormData();
        data.append("form_code", this.form_code);
        data.append("processor", code);
        // Senden
        new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form', 'deactivate_delivery_processor'), data).then((response)=>{
            // Erfolgsmeldung
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
            // Anzeige neu laden
            this.loadProcessors();
        }).catch((error)=>{
            // Fehlermeldung anzeigen
            new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().error(error.message);
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-delivery')) new $662b46652c6834b5$export$6955bcca4cd3539f();
});







class $41fa1bd00f7ada9d$export$6955bcca4cd3539f {
    constructor(){
        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;
        // Basis-URL zu Prozessor
        this.baseUrl = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form-delivery') + "/" + this.form_code + "/mailing";
        // --- Empfängeradressen
        new (0, $d2ddf2bf1b02f675$export$300e34223a1d535f)('#mailaddresses', 'form', this.form_code);
        // --- Antwortadresse
        // Elemente
        this.$btnEditReplyto = document.querySelector('button.replyto');
        this.$inputEditReplyto = document.querySelector('#modal-edit-replyto input[name=replyto]');
        this.$displayReplyto = document.querySelector('#value_replyto');
        this.$displayReplytoEmpty = document.querySelector('#value_replyto_empty');
        this.$formEditReplyto = document.querySelector('#modal-edit-replyto form');
        this.$errorboxEditReplyto = document.querySelector('#modal-edit-replyto .errorbox');
        // Modal
        this.modalEditReplyto = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-replyto');
        // Modaldialog öffnen
        this.$btnEditReplyto.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditReplyto.classList.add('hidden');
            // Modal öffnen
            this.modalEditReplyto.show();
        });
        // Speicherung
        this.$formEditReplyto.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("replyto", this.$inputEditReplyto.value);
            // Fehler ausblenden
            this.$errorboxEditReplyto.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + '/save_replyto', data).then((response)=>{
                // Modal schliessen
                this.modalEditReplyto.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                if (this.$inputEditReplyto.value.trim() == '') {
                    this.$displayReplyto.classList.add('hidden');
                    this.$displayReplytoEmpty.classList.remove('hidden');
                } else {
                    this.$displayReplyto.classList.remove('hidden');
                    this.$displayReplytoEmpty.classList.add('hidden');
                    this.$displayReplyto.textContent = this.$inputEditReplyto.value;
                }
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditReplyto.querySelector('.cont').textContent = error.message;
                this.$errorboxEditReplyto.classList.remove('hidden');
            });
        });
        // --- Betreff
        // Elemente
        this.$btnEditSubject = document.querySelector('button.subject');
        this.$inputEditSubject = document.querySelector('#modal-edit-subject input[name=subject]');
        this.$displaySubject = document.querySelector('#value_subject');
        this.$displaySubjectEmpty = document.querySelector('#value_subject_empty');
        this.$formEditSubject = document.querySelector('#modal-edit-subject form');
        this.$errorboxEditSubject = document.querySelector('#modal-edit-subject .errorbox');
        // Modal
        this.modalEditSubject = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-subject');
        // Modaldialog öffnen
        this.$btnEditSubject.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditSubject.classList.add('hidden');
            // Modal öffnen
            this.modalEditSubject.show();
        });
        // Speicherung
        this.$formEditSubject.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("subject", this.$inputEditSubject.value);
            // Fehler ausblenden
            this.$errorboxEditSubject.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + '/save_subject', data).then((response)=>{
                // Modal schliessen
                this.modalEditSubject.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                if (this.$inputEditSubject.value.trim() == '') {
                    this.$displaySubject.classList.add('hidden');
                    this.$displaySubjectEmpty.classList.remove('hidden');
                } else {
                    this.$displaySubject.classList.remove('hidden');
                    this.$displaySubjectEmpty.classList.add('hidden');
                    this.$displaySubject.textContent = this.$inputEditSubject.value;
                }
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditSubject.querySelector('.cont').textContent = error.message;
                this.$errorboxEditSubject.classList.remove('hidden');
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-delivery-mailing')) new $41fa1bd00f7ada9d$export$6955bcca4cd3539f();
});






class $d41f932fcc39b3da$export$6955bcca4cd3539f {
    constructor(){
        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;
        // Basis-URL zu Prozessor
        this.baseUrl = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form-delivery') + "/" + this.form_code + "/autoresponse";
        // --- Feldname
        // Elemente
        this.$btnEditFieldname = document.querySelector('button.fieldname');
        this.$inputEditFieldname = document.querySelector('#modal-edit-fieldname input[name=fieldname]');
        this.$displayFieldname = document.querySelector('#value_fieldname');
        this.$formEditFieldname = document.querySelector('#modal-edit-fieldname form');
        this.$errorboxEditFieldname = document.querySelector('#modal-edit-fieldname .errorbox');
        // Modal
        this.modalEditFieldname = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-fieldname');
        // Modaldialog öffnen
        this.$btnEditFieldname.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditFieldname.classList.add('hidden');
            // Modal öffnen
            this.modalEditFieldname.show();
        });
        // Speicherung
        this.$formEditFieldname.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("fieldname", this.$inputEditFieldname.value);
            // Fehler ausblenden
            this.$errorboxEditFieldname.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + "/save_fieldname", data).then((response)=>{
                // Modal schliessen
                this.modalEditFieldname.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayFieldname.textContent = this.$inputEditFieldname.value;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditFieldname.querySelector('.cont').textContent = error.message;
                this.$errorboxEditFieldname.classList.remove('hidden');
            });
        });
        // --- Absendername
        // Elemente
        this.$btnEditFromName = document.querySelector('button.mailfromname');
        this.$inputEditFromName = document.querySelector('#modal-edit-mailfromname input[name=mail_from_name]');
        this.$displayFromName = document.querySelector('#value_mailfromname');
        this.$formEditFromName = document.querySelector('#modal-edit-mailfromname form');
        this.$errorboxEditFromName = document.querySelector('#modal-edit-mailfromname .errorbox');
        // Modal
        this.modalEditFromName = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-mailfromname');
        // Modaldialog öffnen
        this.$btnEditFromName.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditFromName.classList.add('hidden');
            // Modal öffnen
            this.modalEditFromName.show();
        });
        // Speicherung
        this.$formEditFromName.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("mail_from_name", this.$inputEditFromName.value);
            // Fehler ausblenden
            this.$errorboxEditFromName.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + "/save_mailfromname", data).then((response)=>{
                // Modal schliessen
                this.modalEditFromName.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayFromName.textContent = this.$inputEditFromName.value;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditFromName.querySelector('.cont').textContent = error.message;
                this.$errorboxEditFromName.classList.remove('hidden');
            });
        });
        // --- Antwortadresse
        // Elemente
        this.$btnEditReplyAddress = document.querySelector('button.mailreplyaddress');
        this.$inputEditReplyAddress = document.querySelector('#modal-edit-mailreplyaddress input[name=mail_reply_address]');
        this.$displayReplyAddress = document.querySelector('#value_mailreplyaddress');
        this.$formEditReplyAddress = document.querySelector('#modal-edit-mailreplyaddress form');
        this.$errorboxEditReplyAddress = document.querySelector('#modal-edit-mailreplyaddress .errorbox');
        // Modal
        this.modalEditReplyAddress = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-mailreplyaddress');
        // Modaldialog öffnen
        this.$btnEditReplyAddress.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditReplyAddress.classList.add('hidden');
            // Modal öffnen
            this.modalEditReplyAddress.show();
        });
        // Speicherung
        this.$formEditReplyAddress.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("mail_reply_address", this.$inputEditReplyAddress.value);
            // Fehler ausblenden
            this.$errorboxEditReplyAddress.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + "/save_mailreplyaddress", data).then((response)=>{
                // Modal schliessen
                this.modalEditReplyAddress.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayReplyAddress.textContent = this.$inputEditReplyAddress.value;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditReplyAddress.querySelector('.cont').textContent = error.message;
                this.$errorboxEditReplyAddress.classList.remove('hidden');
            });
        });
        // --- Betreff
        // Elemente
        this.$btnEditSubject = document.querySelector('button.mailsubject');
        this.$inputEditSubject = document.querySelector('#modal-edit-mailsubject input[name=mailsubject]');
        this.$displaySubject = document.querySelector('#value_mailsubject');
        this.$formEditSubject = document.querySelector('#modal-edit-mailsubject form');
        this.$errorboxEditSubject = document.querySelector('#modal-edit-mailsubject .errorbox');
        // Modal
        this.modalEditSubject = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-mailsubject');
        // Modaldialog öffnen
        this.$btnEditSubject.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditSubject.classList.add('hidden');
            // Modal öffnen
            this.modalEditSubject.show();
        });
        // Speicherung
        this.$formEditSubject.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("mail_subject", this.$inputEditSubject.value);
            // Fehler ausblenden
            this.$errorboxEditSubject.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + "/save_mailsubject", data).then((response)=>{
                // Modal schliessen
                this.modalEditSubject.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displaySubject.textContent = this.$inputEditSubject.value;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditSubject.querySelector('.cont').textContent = error.message;
                this.$errorboxEditSubject.classList.remove('hidden');
            });
        });
        // --- Textinhalt
        // Elemente
        this.$btnEditContent = document.querySelector('button.mailcontent');
        this.$inputEditContent = document.querySelector('#modal-edit-mailcontent textarea[name=mailcontent]');
        this.$displayContent = document.querySelector('#value_mailcontent');
        this.$formEditContent = document.querySelector('#modal-edit-mailcontent form');
        this.$errorboxEditContent = document.querySelector('#modal-edit-mailcontent .errorbox');
        // Modal
        this.modalEditContent = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-mailcontent');
        // Modaldialog öffnen
        this.$btnEditContent.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditContent.classList.add('hidden');
            // Modal öffnen
            this.modalEditContent.show();
        });
        // Speicherung
        this.$formEditContent.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("mail_content", this.$inputEditContent.value);
            // Fehler ausblenden
            this.$errorboxEditContent.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + "/save_mailcontent", data).then((response)=>{
                // Modal schliessen
                this.modalEditContent.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                let text = this.$inputEditContent.value;
                text = (text + '').replace(/[\u00A0-\u9999<>\&]/g, (i)=>`&#${i.charCodeAt(0)};`);
                text = (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
                this.$displayContent.innerHTML = text;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditContent.querySelector('.cont').textContent = error.message;
                this.$errorboxEditContent.classList.remove('hidden');
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-delivery-autoresponse')) new $d41f932fcc39b3da$export$6955bcca4cd3539f();
});







class $bf7dc5f1dd16df59$export$6955bcca4cd3539f {
    constructor(){
        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;
        // Basis-URL zu Prozessor
        this.baseUrl = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form-delivery') + "/" + this.form_code + "/webhook";
        // --- Webadresse
        // Elemente
        this.$btnEditUrl = document.querySelector('button.url');
        this.$inputEditUrl = document.querySelector('#modal-edit-url input[name=url]');
        this.$displayUrl = document.querySelector('#value_url');
        this.$formEditUrl = document.querySelector('#modal-edit-url form');
        this.$errorboxEditUrl = document.querySelector('#modal-edit-url .errorbox');
        // Modal
        this.modalEditUrl = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-url');
        // Modaldialog öffnen
        this.$btnEditUrl.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEditUrl.classList.add('hidden');
            // Modal öffnen
            this.modalEditUrl.show();
        });
        // Speicherung
        this.$formEditUrl.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("url", this.$inputEditUrl.value);
            // Fehler ausblenden
            this.$errorboxEditUrl.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + "/save_url", data).then((response)=>{
                // Modal schliessen
                this.modalEditUrl.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayUrl.textContent = this.$inputEditUrl.value;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEditUrl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditUrl.classList.remove('hidden');
            });
        });
        // Kopierfunktion für Authentifizierungsdaten
        const btnsCopy = document.querySelectorAll("a.copy");
        btnsCopy.forEach(($btnCopy)=>{
            const templateClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnCopy, {
                text: function(trigger) {
                    const selectorStr = trigger.dataset.selectorId ?? null;
                    console.log(selectorStr);
                    if (selectorStr) {
                        const $ele = document.querySelector("#" + selectorStr);
                        if ($ele) {
                            let text = $ele.textContent.trim();
                            return text;
                        }
                    }
                }
            });
            templateClipboard.on('success', (event)=>{
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(msg);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-delivery-webhook')) new $bf7dc5f1dd16df59$export$6955bcca4cd3539f();
});






class $b45bed1a30472b07$export$6955bcca4cd3539f {
    constructor(){
        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;
        // Basis-URL zu Prozessor
        this.baseUrl = (0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('form-delivery') + "/" + this.form_code + "/whatsapp";
        // --- Webadresse
        // Elemente
        this.$btnEdit = document.querySelector('button.phonenumber');
        this.$inputEdit = document.querySelector('#modal-edit-phonenumber input[name=phonenumber]');
        this.$displayValue = document.querySelector('#value_phonenumber');
        this.$formEdit = document.querySelector('#modal-edit-phonenumber form');
        this.$errorboxEdit = document.querySelector('#modal-edit-phonenumber .errorbox');
        // Modal
        this.modalEdit = new (0, $4375d2d61ae6c0ef$export$2b77a92f1a5ad772)('#modal-edit-phonenumber');
        // Modaldialog öffnen
        this.$btnEdit.addEventListener('click', (event)=>{
            // Fehlermeldung ausblenden
            this.$errorboxEdit.classList.add('hidden');
            // Modal öffnen
            this.modalEdit.show();
        });
        // Speicherung
        this.$formEdit.addEventListener('submit', (event)=>{
            event.preventDefault();
            const data = new FormData();
            data.append("phonenumber", this.$inputEdit.value);
            // Fehler ausblenden
            this.$errorboxEdit.classList.add('hidden');
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(this.baseUrl + "/save_phonenumber", data).then((response)=>{
                // Modal schliessen
                this.modalEdit.close();
                // Erfolgsmeldung
                new (0, $5ee7bd5bf24e1c7b$export$14834abbfce3b8cd)().success(response.msg);
                // in Anzeige übernehmen
                this.$displayValue.textContent = response.phonenumber;
            }).catch((error)=>{
                // Fehlermeldung anzeigen
                this.$errorboxEdit.querySelector('.cont').textContent = error.message;
                this.$errorboxEdit.classList.remove('hidden');
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('form-delivery-whatsapp')) new $b45bed1a30472b07$export$6955bcca4cd3539f();
});





class $0748dd83eda68194$export$6955bcca4cd3539f {
    constructor(){
        // Elemente
        const $panelContainer = document.getElementById('panel-container');
        const $panelEmail = document.getElementById('panel-email');
        const $panelForm = document.getElementById('panel-form');
        const $btnBack = $panelForm.querySelector('a.back');
        // Event: Absenden der Email-Adresse
        $panelEmail.addEventListener('submit', (event)=>{
            event.preventDefault();
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($panelEmail);
            // Übermittlung
            const formData = new FormData($panelEmail);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('create-endpoint', 'validate_email'), formData).then((response)=>{
                // Fehlermeldung ausblenden
                const $otherErrorbox = $panelForm.querySelector('.errorbox');
                $otherErrorbox.classList.add('hidden');
                // zur Formulareingabe
                $panelEmail.classList.add('hidden');
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelForm, 'swoopInRight');
                $panelForm.classList.remove('hidden');
            }).catch((error)=>{
                const $errorbox = $panelEmail.querySelector('.errorbox');
                const $cont = $errorbox.querySelector('.cont');
                const $cont_exists = $errorbox.querySelector('.cont_exists');
                $errorbox.classList.remove('hidden');
                // Account bereits vorhanden
                if (error.message == "exists") {
                    $cont.classList.add('hidden');
                    $cont_exists.classList.remove('hidden');
                } else {
                    $cont.classList.remove('hidden');
                    $cont_exists.classList.add('hidden');
                    $cont.innerHTML = error.message;
                    (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($errorbox, 'pullUp');
                }
                // Box schütteln
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelContainer, 'shake');
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($panelEmail);
            });
        });
        // Event: Zurück
        $btnBack.addEventListener('click', (event)=>{
            event.preventDefault();
            // Fehlermeldung ausblenden
            $panelEmail.querySelector('.errorbox').classList.add('hidden');
            // Email-Eingabe einblenden
            $panelForm.classList.add('hidden');
            (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelEmail, 'swoopInLeft');
            $panelEmail.classList.remove('hidden');
        });
        // Event: Einrichten
        $panelForm.addEventListener('submit', (event)=>{
            event.preventDefault();
            // Sendebutton deaktivieren
            (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnLoading($panelForm);
            // Übermittlung
            const formData = new FormData($panelForm);
            const $emailField = $panelEmail.querySelector("#email");
            formData.append("email", $emailField.value);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $bd2663108f285dbc$export$86fbec116b87613f).getUrl('create-endpoint', 'create'), formData).then((response)=>{
                // Weiterleitung zur Integration
                (0, $bd2663108f285dbc$export$86fbec116b87613f).goto('form', 'installation', response.form_code);
            }).catch((error)=>{
                const $errorbox = $panelForm.querySelector('.errorbox');
                const $cont = $errorbox.querySelector('.cont');
                $errorbox.classList.remove('hidden');
                // Fehlermeldung anzeigen
                $cont.classList.remove('hidden');
                $cont.innerHTML = error.message;
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($errorbox, 'pullUp');
                // Box schütteln
                (0, $bd2663108f285dbc$export$86fbec116b87613f).animateCSS($panelContainer, 'shake');
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $bd2663108f285dbc$export$86fbec116b87613f).setSubmitBtnActive($panelForm);
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('create-endpoint')) new $0748dd83eda68194$export$6955bcca4cd3539f();
});


// alle Popups initialisieren
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    window.Popups = [];
    const popups = document.querySelectorAll(".popup");
    popups.forEach(($ele)=>{
        const p = new (0, $d19f7743c2a8a520$export$129a32eedafa97c5)($ele, (instance)=>{
            window.Popups.forEach((p)=>{
                if (p !== instance) p.close();
            });
        });
        window.Popups.push(p);
    });
});
// alle Switches initialisieren
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    const switches = document.querySelectorAll("button.switch");
    switches.forEach(($ele)=>{
        new (0, $fbae5fa1d8d96e27$export$b5d5cf8927ab7262)($ele);
    });
});
// Mobile-Nav in Topbar ein- & ausblenden
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    const $containerBtn = document.querySelector(".topbar .mobile-menu");
    if (!$containerBtn) return;
    const $btnOpenNav = $containerBtn.querySelector(".topbar .mobile-menu button");
    const $navArea = document.querySelector("#mobile-menu-display");
    $btnOpenNav.addEventListener("click", (event)=>{
        event.stopPropagation();
        // Schliessen
        if ($containerBtn.classList.contains("open")) {
            $containerBtn.classList.remove("open");
            $btnOpenNav.removeAttribute("aria-expanded");
            $navArea.classList.remove("open");
            $navArea.addEventListener('transitionend', (e)=>{
                $navArea.style.display = "none";
            }, {
                once: true
            });
        } else {
            $navArea.style.display = "block";
            setTimeout(()=>{
                $containerBtn.classList.add("open");
                $btnOpenNav.setAttribute("aria-expanded", true);
                $navArea.classList.add("open");
            }, "1");
        }
    });
});
// Notifications-Menu initialisieren
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    new (0, $85ad013a94768a89$export$f2c57338dfba4648)();
});
// Seitenwechsel per Select bei Formular-Bereich
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    const $select = document.querySelector("#select-form-area");
    if ($select) $select.addEventListener("change", (event)=>{
        const value = $select.value;
        // Seite aufrufen
        (0, $bd2663108f285dbc$export$86fbec116b87613f).gotoUrl(value);
    });
});
// Matomo
let $17278395fc86fe19$var$_paq = window._paq = window._paq || [];
$17278395fc86fe19$var$_paq.push([
    "setDoNotTrack",
    true
], [
    "disableCookies"
], [
    'trackPageView'
], [
    'enableLinkTracking'
]);
(0, $bd2663108f285dbc$export$86fbec116b87613f).domready(()=>{
    const u = "https://matomo.form.taxi/";
    $17278395fc86fe19$var$_paq.push([
        'setTrackerUrl',
        u + 'matomo.php'
    ], [
        'setSiteId',
        '1'
    ]);
    const $script = document.createElement('script');
    $script.setAttribute('async', true);
    $script.setAttribute('src', u + 'matomo.js');
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore($script, s);
});

})();
//# sourceMappingURL=panel.js.map
